/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./scripts/components/constants/index.js":
/*!***********************************************!*\
  !*** ./scripts/components/constants/index.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ANNOUNCEMENT_BAR_HEIGHT: () => (/* binding */ ANNOUNCEMENT_BAR_HEIGHT),
/* harmony export */   ANNOUNCEMENT_SESSION_NAME: () => (/* binding */ ANNOUNCEMENT_SESSION_NAME)
/* harmony export */ });
var ANNOUNCEMENT_SESSION_NAME = 'announcement-1';
var ANNOUNCEMENT_BAR_HEIGHT = 32;

/***/ }),

/***/ "./scripts/components/core/accordion.js":
/*!**********************************************!*\
  !*** ./scripts/components/core/accordion.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var group = node.dataset.group;
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    inner = _choozy.inner,
    toggle = _choozy.toggle;
  var activeClass = 'open';
  var updateHeight = function updateHeight() {
    node.style.setProperty('--innerHeight', "auto");
    node.style.setProperty('--innerHeight', "".concat(inner.scrollHeight, "px"));
  };
  updateHeight();
  window.addEventListener('resize', updateHeight, {
    passive: true
  });
  toggle.addEventListener('click', function () {
    ctx.emit('accordion:toggle', null, {
      open: !node.classList.contains(activeClass),
      node: node,
      group: group
    });
  });
  ctx.on('accordion:toggle', function (state) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (group !== a.group) return;
    node.classList[a.open && a.node === node ? 'add' : 'remove'](activeClass);
  });
}));

/***/ }),

/***/ "./scripts/components/core/announcement-bar.js":
/*!*****************************************************!*\
  !*** ./scripts/components/core/announcement-bar.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/waitToLoad */ "./scripts/lib/waitToLoad.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants */ "./scripts/components/constants/index.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node, ctx) {
    var _choozy, close, timeToNextSlide, animationSpeed, sliderInit;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null), close = _choozy.close;
          ctx.emit('announcement:exists', {
            announcementExists: true
          });
          if (sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__.ANNOUNCEMENT_SESSION_NAME) !== 'closed') sessionStorage.removeItem(_constants__WEBPACK_IMPORTED_MODULE_2__.ANNOUNCEMENT_SESSION_NAME);
          if (close) close.addEventListener('click', function () {
            node.classList.add('closed');
            sessionStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_2__.ANNOUNCEMENT_SESSION_NAME, 'closed');
            ctx.emit('announcement:closed');
          });
          _context.next = 6;
          return (0,_lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__["default"])('Keen slider');
        case 6:
          // Remove keen slider default styling
          node.classList.remove('flex-col');
          timeToNextSlide = 5000; // ms
          animationSpeed = 750; // ms
          sliderInit = new KeenSlider(node, {
            loop: true,
            drag: false,
            vertical: true,
            defaultAnimation: {
              duration: animationSpeed
            },
            slides: {
              perView: 1
            }
          }, [function (slider) {
            var timeout;
            var sliderLength = 0;
            function nextTimeout() {
              clearTimeout(timeout);
              timeout = setTimeout(function () {
                if (sliderLength > 0) {
                  slider.next();
                }
              }, timeToNextSlide);
            }
            slider.on('created', function () {
              nextTimeout();
              sliderLength = slider.track.details.length;
            });
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
          }]);
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/core/body.js":
/*!*****************************************!*\
  !*** ./scripts/components/core/body.js ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* eslint-disable no-unused-expressions */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  // Make window.innerHeight available in CSS (for iOS)
  document.documentElement.style.setProperty('--windowHeight', "".concat(window.innerHeight, "px"));
  var scrollPosition = 0;
  var readyToLock = false;

  // this is so that the email validation scrollIntoView does not get cancelled by this upon refresh
  setTimeout(function () {
    readyToLock = true;
  }, 1500);
  ctx.on('body:toggleScroll', function (_ref) {
    var enable = _ref.enable;
    if (node.dataset.template === 'product' && window.innerWidth <= 1024) {
      if (enable) {
        scrollPosition = window.pageYOffset;
        node.style.position = 'fixed';
        node.style.top = "-".concat(scrollPosition, "px");
        node.style.width = '100%';
        node.style.overflow = 'hidden';
      } else {
        node.style.removeProperty('position');
        node.style.removeProperty('top');
        node.style.removeProperty('width');
      }
      return;
    }
    if (enable) {
      scrollPosition = window.pageYOffset;
      node.style.overflow = 'hidden';
      node.style.position = 'fixed';
      node.style.top = "-".concat(scrollPosition, "px");
      node.style.width = '100%';
    } else {
      node.style.removeProperty('overflow');
      node.style.removeProperty('position');
      node.style.removeProperty('top');
      node.style.removeProperty('width');
      if (readyToLock) window.scrollTo(0, scrollPosition);
    }
  });
  ctx.on('wishlist:remove', function (_, _ref2) {
    var variantGroupId = _ref2.variantGroupId;
    var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
      addToWishlistBtn = _choozy.addToWishlistBtn;
    var addToWishlistBtnList = addToWishlistBtn && [].concat(addToWishlistBtn);
    var activeBtn = addToWishlistBtnList.find(function (btn) {
      return btn.dataset.variantGroupId === variantGroupId;
    });
    activeBtn && activeBtn.classList.remove('in-wishlist');
  });
}));

/***/ }),

/***/ "./scripts/components/core/cart-drawer.js":
/*!************************************************!*\
  !*** ./scripts/components/core/cart-drawer.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/cart */ "./scripts/lib/cart.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_listeners__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/listeners */ "./scripts/lib/listeners.js");
/* harmony import */ var _lib_waitToLoad__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/waitToLoad */ "./scripts/lib/waitToLoad.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }




var createElementFromHTML = function createElementFromHTML(htmlString) {
  var div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node, ctx) {
    var searchParams, parent, el, _choozy, clear, focusEl, slider, invisible, toggleDrawer, updateToggleHandlers, sliderInit;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          searchParams = new URLSearchParams(window.location.search);
          if (searchParams.get('cart-open') === 'true') {
            ctx.emit('cart:toggle', function () {
              return {
                cartOpen: true
              };
            });
          }
          parent = node.parentNode;
          el = node;
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null), clear = _choozy.clear, focusEl = _choozy.focusEl, slider = _choozy.slider, invisible = _choozy.invisible;
          if (!slider) {
            _context.next = 9;
            break;
          }
          [].concat(invisible).forEach(function (el) {
            return el.classList.remove('invisible');
          });
          _context.next = 9;
          return (0,_lib_waitToLoad__WEBPACK_IMPORTED_MODULE_3__["default"])('Keen slider');
        case 9:
          toggleDrawer = function toggleDrawer(_ref2) {
            var cartOpen = _ref2.cartOpen;
            ctx.emit('body:toggleScroll', function () {
              return {
                enable: cartOpen
              };
            });
            node.classList[cartOpen ? 'add' : 'remove']('open');
            if (cartOpen) {
              el.tabIndex = '0';
              (focusEl || node).focus();
            } else {
              el.tabIndex = '-1';
            }
          };
          updateToggleHandlers = function updateToggleHandlers() {
            var _choozy2 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null),
              toggle = _choozy2.toggle;
            toggle.forEach(function (btn) {
              btn.addEventListener('click', function () {
                ctx.emit('cart:toggle', function (_ref3) {
                  var _cartOpen;
                  var cartOpen = _ref3.cartOpen;
                  return {
                    cartOpen: (_cartOpen = !cartOpen) !== null && _cartOpen !== void 0 ? _cartOpen : true
                  };
                });
              });
            });
          };
          updateToggleHandlers();
          toggleDrawer(ctx.getState());
          if (clear) clear.addEventListener('click', function () {
            return (0,_lib_cart__WEBPACK_IMPORTED_MODULE_0__.clearCart)();
          });
          node.addEventListener('keyup', function (e) {
            return (0,_lib_listeners__WEBPACK_IMPORTED_MODULE_2__["default"])(e, {
              type: 'cart:toggle',
              "boolean": 'cartOpen'
            });
          });
          ctx.on('cart:render', function (_ref4) {
            var cart = _ref4.cart;
            if (parent) {
              var cartElement = createElementFromHTML(cart.sections['cart-drawer']);
              var _choozy3 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(cartElement, null),
                container = _choozy3.container;
              el.innerHTML = container.innerHTML;
              updateToggleHandlers();
            }
            window.app.unmount();
            window.app.mount();
          });
          ctx.on('cart:toggle', toggleDrawer);
          if (slider) {
            sliderInit = new KeenSlider(slider, {
              slides: {
                perView: 1.5,
                spacing: 12,
                origin: 'center'
              },
              loop: true
            });
          }
          return _context.abrupt("return", function () {
            ctx.on(['cart:toggle', 'cart:render'], function () {})();
            node.removeEventListener('keyup', function (e) {
              return (0,_lib_listeners__WEBPACK_IMPORTED_MODULE_2__["default"])(e, {
                type: 'cart:toggle',
                "boolean": 'cartOpen'
              });
            });
          });
        case 19:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/core/cart-item.js":
/*!**********************************************!*\
  !*** ./scripts/components/core/cart-item.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/cart */ "./scripts/lib/cart.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null),
    update = _choozy.update;
  var key = node.dataset.key;
  [].concat(update).forEach(function (btn) {
    var value = btn.dataset.value;
    btn.addEventListener('click', function () {
      return (0,_lib_cart__WEBPACK_IMPORTED_MODULE_0__.updateAddon)(key, value);
    });
  });
}));

/***/ }),

/***/ "./scripts/components/core/color-swatches.js":
/*!***************************************************!*\
  !*** ./scripts/components/core/color-swatches.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    colorOption = _choozy.colorOption,
    swatchElipses = _choozy.swatchElipses,
    swatchDiv = _choozy.swatchDiv;
  var colorOptions = colorOption ? [].concat(colorOption) : [];
  var onChangeColor = function onChangeColor(option) {
    var selectedColorOption = colorOptions.find(function (o) {
      return o.classList.contains('open');
    });
    selectedColorOption.classList.remove('open');
    option.classList.add('open');
    ctx.emit('variant-color:change', null, _objectSpread({}, option.dataset));

    // on mobile if color swatch is active second click will go to url
    if (window.innerWidth < 768) {
      var goToPdp = function goToPdp() {
        window.location = selectedColorOption.dataset.href;
      };
      var unselectedColorOptions = colorOptions.filter(function (o) {
        return !o.classList.contains('open');
      });
      selectedColorOption.addEventListener('click', goToPdp);
      unselectedColorOptions.forEach(function (oEl) {
        return oEl.removeEventListener('click', goToPdp);
      });
    }
  };
  colorOptions.forEach(function (option) {
    if (option.dataset.available === 'true') {
      option.addEventListener('pointerenter', function () {
        return onChangeColor(option);
      });
    }

    // on desktop go to url on click
    if (window.innerWidth >= 768) {
      option.addEventListener('click', function () {
        window.location = option.dataset.href;
      });
    }
  });

  // mobile swatch elipses shows all colors on click
  if (swatchElipses && window.innerWidth < 768) {
    swatchElipses.addEventListener('click', function () {
      swatchElipses.classList.add('hidden-tw');
      [].concat(swatchDiv).forEach(function (div) {
        return div.classList.remove('hidden-tw');
      });
    });
  }
}));

/***/ }),

/***/ "./scripts/components/core/components.js":
/*!***********************************************!*\
  !*** ./scripts/components/core/components.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _section_rendering__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./section-rendering */ "./scripts/components/core/section-rendering.js");
/* harmony import */ var _console_log__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./console-log */ "./scripts/components/core/console-log.js");
/* harmony import */ var _accordion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./accordion */ "./scripts/components/core/accordion.js");
/* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./header */ "./scripts/components/core/header.js");
/* harmony import */ var _mobile_menu__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./mobile-menu */ "./scripts/components/core/mobile-menu.js");
/* harmony import */ var _cart_drawer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./cart-drawer */ "./scripts/components/core/cart-drawer.js");
/* harmony import */ var _cart_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cart-item */ "./scripts/components/core/cart-item.js");
/* harmony import */ var _product_item__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./product-item */ "./scripts/components/core/product-item.js");
/* harmony import */ var _product_product_form__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../product/product-form */ "./scripts/components/product/product-form.js");
/* harmony import */ var _product_product_selection__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../product/product-selection */ "./scripts/components/product/product-selection.js");
/* harmony import */ var _announcement_bar__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./announcement-bar */ "./scripts/components/core/announcement-bar.js");
/* harmony import */ var _body__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./body */ "./scripts/components/core/body.js");
/* harmony import */ var _search__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./search */ "./scripts/components/core/search.js");
/* harmony import */ var _predictive_search__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./predictive-search */ "./scripts/components/core/predictive-search.js");
/* harmony import */ var _desktop_search_drawer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./desktop-search-drawer */ "./scripts/components/core/desktop-search-drawer.js");
/* harmony import */ var _wishlist__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./wishlist */ "./scripts/components/core/wishlist.js");
/* harmony import */ var _product_main_product__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../product/main-product */ "./scripts/components/product/main-product.js");
/* harmony import */ var _product_size_select_modal__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../product/size-select-modal */ "./scripts/components/product/size-select-modal.js");
/* harmony import */ var _color_swatches__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./color-swatches */ "./scripts/components/core/color-swatches.js");
/* harmony import */ var _quick_add__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./quick-add */ "./scripts/components/core/quick-add.js");
/* harmony import */ var _product_size_chart__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./product-size-chart */ "./scripts/components/core/product-size-chart.js");
/* harmony import */ var _email_validation__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./email-validation */ "./scripts/components/core/email-validation.js");
/* harmony import */ var _language_form__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./language-form */ "./scripts/components/core/language-form.js");























/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  sectionRendering: _section_rendering__WEBPACK_IMPORTED_MODULE_0__["default"],
  consoleLog: _console_log__WEBPACK_IMPORTED_MODULE_1__["default"],
  accordion: _accordion__WEBPACK_IMPORTED_MODULE_2__["default"],
  header: _header__WEBPACK_IMPORTED_MODULE_3__["default"],
  mobileMenu: _mobile_menu__WEBPACK_IMPORTED_MODULE_4__["default"],
  cartDrawer: _cart_drawer__WEBPACK_IMPORTED_MODULE_5__["default"],
  cartItem: _cart_item__WEBPACK_IMPORTED_MODULE_6__["default"],
  productItem: _product_item__WEBPACK_IMPORTED_MODULE_7__["default"],
  productForm: _product_product_form__WEBPACK_IMPORTED_MODULE_8__["default"],
  mainProduct: _product_main_product__WEBPACK_IMPORTED_MODULE_16__["default"],
  productSelection: _product_product_selection__WEBPACK_IMPORTED_MODULE_9__["default"],
  sizeSelectModal: _product_size_select_modal__WEBPACK_IMPORTED_MODULE_17__["default"],
  announcementBar: _announcement_bar__WEBPACK_IMPORTED_MODULE_10__["default"],
  body: _body__WEBPACK_IMPORTED_MODULE_11__["default"],
  search: _search__WEBPACK_IMPORTED_MODULE_12__["default"],
  predictiveSearch: _predictive_search__WEBPACK_IMPORTED_MODULE_13__["default"],
  desktopSearchDrawer: _desktop_search_drawer__WEBPACK_IMPORTED_MODULE_14__["default"],
  wishlist: _wishlist__WEBPACK_IMPORTED_MODULE_15__["default"],
  colorSwatches: _color_swatches__WEBPACK_IMPORTED_MODULE_18__["default"],
  quickAdd: _quick_add__WEBPACK_IMPORTED_MODULE_19__["default"],
  productSizeChart: _product_size_chart__WEBPACK_IMPORTED_MODULE_20__["default"],
  emailValidation: _email_validation__WEBPACK_IMPORTED_MODULE_21__["default"],
  languageForm: _language_form__WEBPACK_IMPORTED_MODULE_22__["default"]
});

/***/ }),

/***/ "./scripts/components/core/console-log.js":
/*!************************************************!*\
  !*** ./scripts/components/core/console-log.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  var text = node.dataset.text;
  console.log('console:log', text);
}));

/***/ }),

/***/ "./scripts/components/core/desktop-search-drawer.js":
/*!**********************************************************!*\
  !*** ./scripts/components/core/desktop-search-drawer.js ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    desktopSearchToggle = _choozy.desktopSearchToggle,
    desktopSearchDrawer = _choozy.desktopSearchDrawer,
    desktopSearchOverlay = _choozy.desktopSearchOverlay,
    desktopSearchBox = _choozy.desktopSearchBox,
    searchForm = _choozy.searchForm,
    searchIcon = _choozy.searchIcon;
  searchIcon.addEventListener('click', function () {
    searchForm.submit();
  });
  var scrollFunction = function scrollFunction() {
    if (!ctx.getState().enable) {
      node.classList[document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? 'add' : 'remove']('scrolled');
    }
  };
  window.addEventListener('scroll', function () {
    return scrollFunction();
  });

  // ctx.on('announcement:exists', () => {
  //   if (
  //     ctx.getState()?.announcementExists &&
  //     sessionStorage.getItem('announcement-1') !== 'closed' &&
  //     document.documentElement.scrollTop <= 32
  //   )
  //     return (desktopSearchBox.style.paddingTop = `13.2rem`);
  //   return null;
  // });

  // ctx.on('announcement:closed', () => (desktopSearchBox.style.paddingTop = '10rem'));

  // DESKTOP SEARCH TOGGLE
  [].concat(desktopSearchToggle).forEach(function (eachDesktopSearchToggle) {
    eachDesktopSearchToggle.addEventListener('click', function () {
      ctx.emit('desktopSearchToggle', function (_ref) {
        var _desktopSearchOpen;
        var desktopSearchOpen = _ref.desktopSearchOpen;
        return {
          desktopSearchOpen: (_desktopSearchOpen = !desktopSearchOpen) !== null && _desktopSearchOpen !== void 0 ? _desktopSearchOpen : true
        };
      });
    });
  });
  ctx.on('desktopSearchToggle', function (_ref2) {
    var desktopSearchOpen = _ref2.desktopSearchOpen;
    ctx.emit('body:toggleScroll', function () {
      return {
        enable: desktopSearchOpen
      };
    });
    desktopSearchDrawer.classList[desktopSearchOpen ? 'add' : 'remove']('desktop-search-open');
    desktopSearchOverlay.classList[desktopSearchOpen ? 'add' : 'remove']('desktop-search-open');
  });
}));

/***/ }),

/***/ "./scripts/components/core/email-validation.js":
/*!*****************************************************!*\
  !*** ./scripts/components/core/email-validation.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/string */ "./scripts/lib/string.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node) {
    var _choozy, email, error, form;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null), email = _choozy.email, error = _choozy.error;
          form = node;
          if (window.location.search.includes('customer_posted=true') || window.location.search.includes('&form_type=customer')) {
            form.scrollIntoView({
              behavior: 'smooth'
            });
          }
          if (window.location.href.indexOf('&form_type=customer') > -1) {
            error.classList.remove('hidden');
            error.innerHTML = (0,_lib_string__WEBPACK_IMPORTED_MODULE_1__.getString)('newsletter.already_signed_up');
          }
          email.addEventListener('input', function () {
            error.classList.add('hidden');
          });
          form.addEventListener('submit', function (e) {
            e.preventDefault();
            var filter = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (filter.test(email.value)) {
              form.submit();
              return;
            }
            error.innerHTML = (0,_lib_string__WEBPACK_IMPORTED_MODULE_1__.getString)('newsletter.email_error');
            error.classList.remove('hidden');
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/core/header.js":
/*!*******************************************!*\
  !*** ./scripts/components/core/header.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_wishlist_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/wishlist.util */ "./scripts/lib/wishlist.util.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../constants */ "./scripts/components/constants/index.js");
/* eslint-disable no-unused-expressions */
/* eslint-disable no-return-assign */



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _ctx$getState2;
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    cartCount = _choozy.cartCount,
    cartToggle = _choozy.cartToggle,
    logoText = _choozy.logoText,
    hoverItem = _choozy.hoverItem,
    menuItem = _choozy.menuItem,
    menu = _choozy.menu,
    closeMenu = _choozy.closeMenu,
    subMenu = _choozy.subMenu,
    mobileMenuToggle = _choozy.mobileMenuToggle,
    desktopSearchToggle = _choozy.desktopSearchToggle,
    wishlistToggle = _choozy.wishlistToggle;

  // Eventlistener for window resize
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 1023 && !ctx.getState().isMobile) ctx.emit('isMobile', function () {
      return {
        isMobile: true
      };
    });
    if (window.innerWidth < 1023 && ctx.getState().isMobile) ctx.emit('isMobile', function () {
      return {
        isMobile: false
      };
    });
  });

  // hides header when mobile pdp info is up
  ctx.on(['mobilePdpUp', 'isMobile'], function (_ref) {
    var mobilePdpUp = _ref.mobilePdpUp,
      isMobile = _ref.isMobile;
    return node.classList[!isMobile && mobilePdpUp ? 'add' : 'remove']('hide');
  });

  // check if announcement bar is present
  ctx.on('announcement:exists', function () {
    var _ctx$getState;
    if ((_ctx$getState = ctx.getState()) !== null && _ctx$getState !== void 0 && _ctx$getState.announcementExists && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__.ANNOUNCEMENT_SESSION_NAME) !== 'closed' && document.documentElement.scrollTop <= 32) return menu.style.marginTop = "".concat((32 - document.documentElement.scrollTop) / 10, "rem");
    if (menu.style.marginTop !== 0) return menu.style.marginTop = 0;
    return null;
  });
  ctx.on('announcement:closed', function () {
    return menu.style.marginTop = 0;
  });

  // Cart logic
  var updateCartCount = function updateCartCount(cart) {
    if (!(cart !== null && cart !== void 0 && cart.token)) return;
    cartCount.textContent = cart.item_count;
  };
  ctx.on('cart:updated', function (_ref2) {
    var cart = _ref2.cart;
    return updateCartCount(cart);
  });
  cartToggle.addEventListener('click', function (e) {
    e.preventDefault();
    ctx.emit('cart:toggle', function (_ref3) {
      var _cartOpen;
      var cartOpen = _ref3.cartOpen;
      return {
        cartOpen: (_cartOpen = !cartOpen) !== null && _cartOpen !== void 0 ? _cartOpen : true
      };
    });
  });
  updateCartCount((_ctx$getState2 = ctx.getState()) === null || _ctx$getState2 === void 0 ? void 0 : _ctx$getState2.cart);

  // Header scroll logic
  var scrollFunction = function scrollFunction() {
    var _ctx$getState3;
    if ((_ctx$getState3 = ctx.getState()) !== null && _ctx$getState3 !== void 0 && _ctx$getState3.announcementExists && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_2__.ANNOUNCEMENT_SESSION_NAME) !== 'closed' && document.documentElement.scrollTop <= 32) {
      menu.style.marginTop = "".concat((32 - document.documentElement.scrollTop) / 10, "rem");
    } else if (menu.style.marginTop !== 0) menu.style.marginTop = 0;
    if (!ctx.getState().enable) {
      node.classList[document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? 'add' : 'remove']('scrolled');
    }
  };
  window.addEventListener('scroll', function () {
    return scrollFunction();
  });
  // Add the css transitions back in after load
  logoText.classList.add('transition-all', '[&_path]:transition-all', '[&_path]:duration-500', 'duration-300', 'ease-in-out');
  node.classList.add('transition-[opacity,background-color]');

  // Menu hover logic
  var toggleSubMenu = function toggleSubMenu(_ref4) {
    var submenuOpen = _ref4.submenuOpen;
    menu.classList[submenuOpen ? 'add' : 'remove']('open');
    node.classList[submenuOpen ? 'add' : 'remove']('open');
  };
  [].concat(hoverItem).forEach(function (hoveredItem) {
    hoveredItem && hoveredItem.addEventListener('mouseover', function (e) {
      if (e.target.classList.contains('menuItem')) {
        hoverItem.forEach(function (each) {
          return each.classList.remove('open');
        });
        e.target.classList.add('open');
        document.body.classList.add('scroll-lock');
      }
      ctx.emit('submenu:toggle', function () {
        return {
          submenuOpen: true
        };
      });
    });
  });
  menuItem && [].concat(menuItem).forEach(function (hoveredItem) {
    hoveredItem && hoveredItem.addEventListener('mouseenter', function (e) {
      [].concat(subMenu).forEach(function (sub) {
        sub.classList.add('hidden-tw');
        sub.classList.remove('flex');
        if (sub.dataset.key === e.target.dataset.key) {
          sub.classList.add('flex');
          sub.classList.remove('hidden-tw');
        }
      });
    });
  });
  [].concat(closeMenu).forEach(function (eachCloseMenu) {
    eachCloseMenu.addEventListener('mouseenter', function () {
      document.body.classList.remove('scroll-lock');
      ctx.emit('submenu:toggle', function () {
        return {
          submenuOpen: false
        };
      });
      hoverItem.forEach(function (eachHoverItem) {
        return eachHoverItem.classList.remove('open');
      });
    });
  });
  toggleSubMenu(ctx.getState());
  ctx.on('submenu:toggle', toggleSubMenu);

  // DESKTOP SEARCH TOGGLE
  [].concat(desktopSearchToggle).forEach(function (eachDesktopSearchToggle) {
    eachDesktopSearchToggle.addEventListener('click', function () {
      return ctx.emit('desktopSearchToggle', function (_ref5) {
        var _desktopSearchOpen;
        var desktopSearchOpen = _ref5.desktopSearchOpen;
        return {
          desktopSearchOpen: (_desktopSearchOpen = !desktopSearchOpen) !== null && _desktopSearchOpen !== void 0 ? _desktopSearchOpen : true
        };
      });
    });
  });
  ctx.on('desktopSearchToggle', function (_ref6) {
    var desktopSearchOpen = _ref6.desktopSearchOpen;
    return node.classList[desktopSearchOpen ? 'add' : 'remove']('desktop-search-open');
  });

  // MOBILE MENU DRAWER
  [].concat(mobileMenuToggle).forEach(function (eachToggle) {
    eachToggle.addEventListener('click', function (e) {
      e.preventDefault();

      // Here we need to check if the drawer is already open and if its the same menu already open
      // 1. if open and same menu -> close
      // 2. if open and different menu -> switch
      // 3. if not open then open that menu -> open
      ctx.emit('body:toggleScroll', function (_ref7) {
        var _eachToggle$dataset;
        var mobileMenuOpen = _ref7.mobileMenuOpen,
          currentMobileDrawer = _ref7.currentMobileDrawer;
        return {
          enable: !(mobileMenuOpen && currentMobileDrawer === ((_eachToggle$dataset = eachToggle.dataset) === null || _eachToggle$dataset === void 0 ? void 0 : _eachToggle$dataset.key))
        };
      });
      ctx.emit('mobileMenu:toggle', function (_ref8) {
        var _eachToggle$dataset2, _eachToggle$dataset3;
        var mobileMenuOpen = _ref8.mobileMenuOpen,
          currentMobileDrawer = _ref8.currentMobileDrawer;
        return {
          mobileMenuOpen: !(mobileMenuOpen && currentMobileDrawer === ((_eachToggle$dataset2 = eachToggle.dataset) === null || _eachToggle$dataset2 === void 0 ? void 0 : _eachToggle$dataset2.key)),
          currentMobileDrawer: (_eachToggle$dataset3 = eachToggle.dataset) === null || _eachToggle$dataset3 === void 0 ? void 0 : _eachToggle$dataset3.key
        };
      });
    });
  });
  var toggleMobileMenu = function toggleMobileMenu(_ref9) {
    var mobileMenuOpen = _ref9.mobileMenuOpen,
      currentMobileDrawer = _ref9.currentMobileDrawer;
    node.classList[mobileMenuOpen ? 'add' : 'remove']('mobile-open');
    node.classList[currentMobileDrawer === 'nav' ? 'add' : 'remove']('nav-open');
    node.classList[currentMobileDrawer === 'search' ? 'add' : 'remove']('search-open');
    if (mobileMenuOpen) {
      document.body.classList.add('new-nav-open');
    } else {
      document.body.classList.remove('new-nav-open');
    }
  };
  toggleMobileMenu(ctx.getState());
  ctx.on('mobileMenu:toggle', toggleMobileMenu);
  wishlistToggle.addEventListener('click', function () {
    ctx.emit('wishlist:open');
  });
  var renderWishlistIcon = function renderWishlistIcon() {
    var wishlist = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_1__.getWishlist)();
    var _JSON$parse = JSON.parse(wishlist),
      items = _JSON$parse.items;
    var itemsInWishlist = Object.values(items).filter(function (item) {
      return item.inWishlist;
    }).length;
    wishlistToggle.classList[itemsInWishlist > 0 ? 'add' : 'remove']('in-wishlist');
  };
  ctx.on('wishlist:changed', function (_, _ref10) {
    var isInWishlist = _ref10.isInWishlist;
    renderWishlistIcon();
  });
  renderWishlistIcon();
}));

/***/ }),

/***/ "./scripts/components/core/language-form.js":
/*!**************************************************!*\
  !*** ./scripts/components/core/language-form.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    select = _choozy.select;
  if (!select) return;
  var LANGS_ENUM = {
    NL: 'nl',
    DE: 'de',
    FR: 'fr'
  };
  select.addEventListener('change', function (_ref) {
    var target = _ref.target;
    localStorage.setItem('pref_lang', target.value);
    node.submit();
  });
  var currentPath = window.location.pathname;
  var newPath = currentPath !== '/' ? currentPath.split('/') : currentPath;
  var currentPathWithoutLangCountry = newPath !== '/' ? newPath.filter(function (el) {
    return el !== LANGS_ENUM.NL && el !== LANGS_ENUM.FR && el !== LANGS_ENUM.DE;
  }).join('/') : newPath;
  var prefLang = localStorage.getItem('pref_lang');
  var langCountryPart = Object.values(LANGS_ENUM).filter(function (lang) {
    return lang === prefLang;
  })[0] || '';
  var redirectUrl = "".concat(window.location.origin).concat(langCountryPart ? "/".concat(langCountryPart) : '').concat(currentPathWithoutLangCountry).concat(window.location.search);
  var initRedirect = function initRedirect() {
    if (localStorage.getItem('redirect_on_load')) {
      localStorage.removeItem('redirect_on_load');
      var currentPathLang = Object.values(LANGS_ENUM).find(function (lang) {
        return currentPath.split('/').find(function (cp) {
          return cp === lang;
        });
      });

      // if there is no locale in the url (means that the language is set to default(en)) and preferred lang is en - do no redirect
      if (!currentPathLang && prefLang === 'en') {
        localStorage.setItem('redirect_on_load', true);
        return;
      }
      if (currentPathLang && prefLang === 'en' && currentPathLang !== prefLang || prefLang && !currentPath.includes(prefLang)) {
        window.location.href = redirectUrl;
      }
    } else {
      // Set a flag in localStorage to trigger the redirect on next load
      localStorage.setItem('redirect_on_load', true);
    }
  };
  document.onload = initRedirect();
}));

/***/ }),

/***/ "./scripts/components/core/mobile-menu.js":
/*!************************************************!*\
  !*** ./scripts/components/core/mobile-menu.js ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../constants */ "./scripts/components/constants/index.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    mobileMenuDrawer = _choozy.mobileMenuDrawer,
    mobileOverlay = _choozy.mobileOverlay,
    mobileMenuToggle = _choozy.mobileMenuToggle,
    mobileSubmenuItem = _choozy.mobileSubmenuItem,
    mobileSubmenuToggle = _choozy.mobileSubmenuToggle,
    searchForm = _choozy.searchForm,
    searchIcon = _choozy.searchIcon;
  searchIcon.addEventListener('click', function () {
    searchForm.submit();
  });

  // check if announcement bar is present
  ctx.on('announcement:exists', function () {
    var _ctx$getState;
    if ((_ctx$getState = ctx.getState()) !== null && _ctx$getState !== void 0 && _ctx$getState.announcementExists && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__.ANNOUNCEMENT_SESSION_NAME) !== 'closed' && document.documentElement.scrollTop <= 32) {
      mobileMenuDrawer.classList.add('mt-extra');
      mobileMenuDrawer.style.marginTop = "".concat(32 - document.documentElement.scrollTop, "px");
    } else if (mobileMenuDrawer.style.marginTop !== 0) {
      mobileMenuDrawer.classList.remove('mt-extra');
      mobileMenuDrawer.style.marginTop = 0;
    }
  });
  ctx.on('announcement:closed', function () {
    mobileMenuDrawer.style.marginTop = 0;
    mobileMenuDrawer.classList.remove('mt-extra');
  });
  var scrollFunction = function scrollFunction() {
    var _ctx$getState2;
    if ((_ctx$getState2 = ctx.getState()) !== null && _ctx$getState2 !== void 0 && _ctx$getState2.announcementExists && sessionStorage.getItem(_constants__WEBPACK_IMPORTED_MODULE_1__.ANNOUNCEMENT_SESSION_NAME) !== 'closed' && document.documentElement.scrollTop <= 32) {
      mobileMenuDrawer.style.marginTop = "".concat(32 - document.documentElement.scrollTop, "px");
    } else if (mobileMenuDrawer.style.marginTop !== 0 || mobileMenuDrawer.style.marginTop !== '0px') {
      mobileMenuDrawer.style.marginTop = 0;
    }
    if (!ctx.getState().enable) {
      mobileMenuDrawer.classList[document.body.scrollTop > 50 || document.documentElement.scrollTop > 50 ? 'add' : 'remove']('scrolled');
    }
  };
  window.addEventListener('scroll', function () {
    return scrollFunction();
  });

  // MOBILE MENU DRAWER
  [].concat(mobileMenuToggle).forEach(function (eachToggle) {
    eachToggle.addEventListener('click', function (e) {
      e.preventDefault();
      ctx.emit('body:toggleScroll', function (_ref) {
        var _enable;
        var enable = _ref.enable;
        return {
          enable: (_enable = !enable) !== null && _enable !== void 0 ? _enable : true
        };
      });
      ctx.emit('mobileMenu:toggle', function (_ref2) {
        var _mobileMenuOpen;
        var mobileMenuOpen = _ref2.mobileMenuOpen;
        return {
          mobileMenuOpen: (_mobileMenuOpen = !mobileMenuOpen) !== null && _mobileMenuOpen !== void 0 ? _mobileMenuOpen : true
        };
      });
    });
  });
  var toggleMobileMenu = function toggleMobileMenu(_ref3) {
    var mobileMenuOpen = _ref3.mobileMenuOpen;
    mobileMenuDrawer.classList[mobileMenuOpen ? 'add' : 'remove']('mobile-open');
    mobileOverlay.classList[mobileMenuOpen ? 'add' : 'remove']('mobile-open');
  };
  toggleMobileMenu(ctx.getState());
  ctx.on('mobileMenu:toggle', toggleMobileMenu);

  // MOBILE SUB MENU TOGGLE
  var toggleMobileSubMenu = function toggleMobileSubMenu(_ref4) {
    var mobilesubmenuOpen = _ref4.mobilesubmenuOpen;
    mobileMenuDrawer.classList[mobilesubmenuOpen ? 'add' : 'remove']('mobile-sub-open');
  };
  [].concat(mobileSubmenuToggle).forEach(function (eachToggle) {
    eachToggle.addEventListener('click', function () {
      [].concat(mobileSubmenuItem).forEach(function (eachSubMenu) {
        if (ctx.getState().mobilesubmenuOpen) return;
        eachSubMenu.classList.remove('flex');
        eachSubMenu.classList.add('hidden-tw');
        if (eachToggle.dataset.key === eachSubMenu.dataset.key) {
          eachSubMenu.classList.add('flex');
          eachSubMenu.classList.remove('hidden-tw');
        }
      });
      ctx.emit('mobilesubmenu:toggle', function (_ref5) {
        var _mobilesubmenuOpen;
        var mobilesubmenuOpen = _ref5.mobilesubmenuOpen;
        return {
          mobilesubmenuOpen: (_mobilesubmenuOpen = !mobilesubmenuOpen) !== null && _mobilesubmenuOpen !== void 0 ? _mobilesubmenuOpen : true
        };
      });
    });
  });
  ctx.on('mobilesubmenu:toggle', toggleMobileSubMenu);

  // SEARCH AND MENU SWITCHING
  var switchActiveMenu = function switchActiveMenu(currentMobileDrawer) {
    if (currentMobileDrawer === 'nav') {
      node.classList.remove('search-open');
      node.classList.add('nav-open');
    } else if (currentMobileDrawer === 'search') {
      mobileMenuDrawer.classList.remove('mobile-sub-open');
      node.classList.remove('nav-open');
      node.classList.add('search-open');
    }
  };
  ctx.on('mobileMenu:toggle', function (_ref6) {
    var currentMobileDrawer = _ref6.currentMobileDrawer;
    return switchActiveMenu(currentMobileDrawer);
  });
}));

/***/ }),

/***/ "./scripts/components/core/predictive-search.js":
/*!******************************************************!*\
  !*** ./scripts/components/core/predictive-search.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _this = undefined;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-return-assign */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    predictiveSearch = _choozy.predictiveSearch,
    searchInput = _choozy.searchInput,
    defaultContent = _choozy.defaultContent;
  var locale = window.Phill.locale.shop_locale.locale;
  var queryLocaleStr = locale === 'en' ? '' : "/".concat(locale);
  var debounce = function debounce(fn, wait) {
    var t;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(t);
      t = setTimeout(function () {
        return fn.apply(_this, args);
      }, wait);
    };
  };
  var isEmpty = false;
  var showResults = function showResults(open, searchSize) {
    predictiveSearch.classList[open ? 'remove' : 'add']('hidden-tw');
    predictiveSearch.classList[open ? 'add' : 'remove']('block');
    [].concat(defaultContent).forEach(function (each) {
      each.classList[searchSize === '0' || isEmpty ? 'remove' : 'add']('hidden-tw');
      each.classList[searchSize === '0' ? 'add' || 0 : 'remove']('block');
    });
    window.app.mount();
  };
  var fetchHtml = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetch(url).then(function (response) {
              return response.text();
            }).then(function (responseText) {
              return new DOMParser().parseFromString(responseText, 'text/html');
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchHtml(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var getSearchCount = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(searchTerm) {
      var searchCountHtmlRender;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return fetchHtml("".concat(window.location.origin).concat(queryLocaleStr, "/search?q=").concat(searchTerm, "&type=product&sections=search-count"));
          case 2:
            searchCountHtmlRender = _context2.sent;
            return _context2.abrupt("return", searchCountHtmlRender.querySelector('[data-search-count').dataset.searchCount);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function getSearchCount(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getSearchResults = function getSearchResults(searchTerm) {
    var searchQuery = "".concat(queryLocaleStr, "/search/suggest?q=").concat(searchTerm, "&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,variants.sku,body,tag&section_id=predictive-search");
    var searchQuery2 = "".concat(queryLocaleStr, "/search?q=").concat(searchTerm, "&type=product&section_id=predictive-search");
    fetch(searchQuery).then(function (response) {
      if (!response.ok) {
        var error = new Error(response.status);
        showResults(false);
        throw error;
      }
      return response.text();
    }).then( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(text) {
        var hasNoResults, newHtml, _choozy2, displaySearchCount, fullResults, searchCount, inputList, prefix;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              hasNoResults = text.includes('<span data-display-search-count>0</span>&nbsp;Results');
              newHtml = new DOMParser().parseFromString(text, 'text/html');
              _choozy2 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(newHtml, null), displaySearchCount = _choozy2.displaySearchCount, fullResults = _choozy2.fullResults;
              if (fullResults) fullResults.href = "".concat(window.location.origin).concat(queryLocaleStr, "/search?q=").concat(searchTerm, "&type=product");
              if (!hasNoResults) {
                _context3.next = 8;
                break;
              }
              _context3.t0 = 0;
              _context3.next = 11;
              break;
            case 8:
              _context3.next = 10;
              return getSearchCount(searchTerm);
            case 10:
              _context3.t0 = _context3.sent;
            case 11:
              searchCount = _context3.t0;
              inputList = newHtml.querySelectorAll('input[data-size-input]'); // TODO: refactor - combine mobile and desktop search
              // We need this because inputs with same ids are displayed for mobile/desktop, thus breaking the product selection
              prefix = node.dataset.hasOwnProperty('isMobile') ? 'mobile-' : 'desktop-';
              inputList.forEach(function (input) {
                input.id = "".concat(prefix).concat(input.id);
                input.parentNode.setAttribute('for', input.id);
              });
              displaySearchCount.innerHTML = searchCount;
              predictiveSearch.innerHTML = newHtml.querySelector('#shopify-section-predictive-search').innerHTML;
              showResults(true, searchCount);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }())["catch"](function (error) {
      showResults(false);
      throw error;
    })["finally"](function () {
      if (!isEmpty) return;
      showResults(false);
    });
  };
  var onChange = function onChange(e) {
    var searchTerm = e.target.value;
    if (!searchTerm.length) return showResults(false);
    return getSearchResults(searchTerm);
  };

  // if there is already a search term in the input from last search
  // opening the drawer should display the last search result
  if (searchInput.value) {
    getSearchResults(searchInput.value);
  }
  searchInput.addEventListener('input', debounce(function (event) {
    onChange(event);
  }, 300));
  searchInput.addEventListener('input', function () {
    var searchTerm = searchInput.value;
    isEmpty = searchTerm.length === 0;
  });
}));

/***/ }),

/***/ "./scripts/components/core/product-item.js":
/*!*************************************************!*\
  !*** ./scripts/components/core/product-item.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable no-prototype-builtins */

var updateImage = function updateImage(url, imageType) {
  if (url.indexOf('no-image') > -1) return;
  var selectedImage = imageType.length > 1 ? imageType[0] : imageType;
  var sourceOne = selectedImage.querySelectorAll('source');
  sourceOne.forEach(function (source) {
    source.remove();
  });
  var img = selectedImage.querySelector('img');
  img.src = url;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    link = _choozy.link,
    variantImage = _choozy.variantImage,
    productJson = _choozy.productJson;
  var _JSON$parse = JSON.parse(productJson.innerHTML),
    product = _JSON$parse.product;

  // There are 2 elements with the data-link attr, the a tag wrapping the image and the title + price
  var _concat$0$href$split = [].concat(link)[0].href.split('?'),
    _concat$0$href$split2 = _slicedToArray(_concat$0$href$split, 1),
    baseUrl = _concat$0$href$split2[0];
  ctx.on('variant-color:change', function (_, _ref) {
    var variantId = _ref.variantId;
    var newVariant = product.variants.find(function (item) {
      return item.id.toString() === variantId.toString();
    });
    if (!newVariant) return;
    [].concat(link).forEach(function (l) {
      l.href = "".concat(baseUrl, "?variant=").concat(newVariant.id);
    });
    updateImage(newVariant.featured_image.src, variantImage);
  });
}));

/***/ }),

/***/ "./scripts/components/core/product-size-chart.js":
/*!*******************************************************!*\
  !*** ./scripts/components/core/product-size-chart.js ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    sizeGuideClose = _choozy.sizeGuideClose;
  var sizeGuideCloseEls = [].concat(sizeGuideClose);
  sizeGuideCloseEls.forEach(function (el) {
    el.addEventListener('click', function () {
      ctx.emit('sizeChartToggle', function (_ref) {
        var showSizeChart = _ref.showSizeChart;
        return {
          showSizeChart: false
        };
      });
    });
  });
  ctx.on('sizeChartToggle', function (_ref2) {
    var showSizeChart = _ref2.showSizeChart,
      sizeChartType = _ref2.sizeChartType;
    node.querySelectorAll("[data-chart-type]").forEach(function (el) {
      el.classList.remove('is-active');
    });
    node.querySelector("[data-chart-type=\"".concat(sizeChartType, "\"]")).classList.add('is-active');
    if (showSizeChart) {
      ctx.emit('body:toggleScroll', function (_ref3) {
        var enable = _ref3.enable;
        return {
          enable: true
        };
      });
    } else {
      ctx.emit('body:toggleScroll', function (_ref4) {
        var enable = _ref4.enable;
        return {
          enable: false
        };
      });
    }
    node.classList[showSizeChart ? 'add' : 'remove']('open');
  });
}));

/***/ }),

/***/ "./scripts/components/core/quick-add.js":
/*!**********************************************!*\
  !*** ./scripts/components/core/quick-add.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    quickAddBtn = _choozy.quickAddBtn,
    quickAddContainer = _choozy.quickAddContainer,
    closeQuickAddBtn = _choozy.closeQuickAddBtn,
    formContainer = _choozy.formContainer;
  var onCloseQuickAdd = function onCloseQuickAdd() {
    quickAddContainer.classList.remove('is-active');
    ctx.emit('quick-add:close', {
      sizeSelectOpen: false
    });
  };
  quickAddBtn.addEventListener('click', function () {
    return quickAddContainer.classList.add('is-active');
  });
  formContainer.addEventListener('mouseover', function () {
    return quickAddContainer.classList.add('is-active');
  });
  quickAddContainer.addEventListener('mouseout', function () {
    return quickAddContainer.classList.remove('is-active');
  });
  closeQuickAddBtn.addEventListener('click', onCloseQuickAdd);
  ctx.on('quick-add:success', onCloseQuickAdd);
}));

/***/ }),

/***/ "./scripts/components/core/search.js":
/*!*******************************************!*\
  !*** ./scripts/components/core/search.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    popularSearch = _choozy.popularSearch,
    searchInput = _choozy.searchInput,
    searchIcon = _choozy.searchIcon,
    searchForm = _choozy.searchForm;
  searchIcon.addEventListener('click', function () {
    searchForm.submit();
  });

  // SEARCH
  if (popularSearch) {
    [].concat(popularSearch).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.dataset.value;
        searchInput.focus();
        searchInput.value = value;
        var event = new Event('input');
        searchInput.dispatchEvent(event);
      });
    });
  }
}));

/***/ }),

/***/ "./scripts/components/core/section-rendering.js":
/*!******************************************************!*\
  !*** ./scripts/components/core/section-rendering.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function () {
  document.addEventListener('shopify:section:load', function () {
    window.app.unmount();
    window.app.mount();
  });
}));

/***/ }),

/***/ "./scripts/components/core/wishlist.js":
/*!*********************************************!*\
  !*** ./scripts/components/core/wishlist.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_string__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/string */ "./scripts/lib/string.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/wishlist.util */ "./scripts/lib/wishlist.util.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */



var formatOptions = {
  minimumFractionDigits: 2
};
var wishlistJsonData = document.querySelector('#wishlist-data');
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(node, ctx) {
    var _choozy, wishlistCloseBtn, backLayer, wishlistItemTemplate, wishlistGrid, wishlistContainer, wishlistError, wishlistCount, sizeOverrides, emitVariantChange, initWishlist, updateWishlistHandler, updateTemplateHtml, displayWishlistData, displayFetchWishlistError, getWishlistItems, updateWishlistCount, removeFromWishlistGrid;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null), wishlistCloseBtn = _choozy.wishlistCloseBtn, backLayer = _choozy.backLayer, wishlistItemTemplate = _choozy.wishlistItemTemplate, wishlistGrid = _choozy.wishlistGrid, wishlistContainer = _choozy.wishlistContainer, wishlistError = _choozy.wishlistError, wishlistCount = _choozy.wishlistCount;
          sizeOverrides = node.dataset.overrideSizeNames;
          emitVariantChange = function emitVariantChange(variant) {
            ctx.emit('variant:change', null, {
              product: {
                id: variant.productId
              },
              selectedVariant: {
                id: variant.id,
                available: variant.isInStock
              },
              isWishlistItem: true
            });
          };
          initWishlist = function initWishlist() {
            var email = window.Phill.customer.email;
            if (email) {
              var localWishlist = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.getWishlist)();
              var localWishlistData = localWishlist ? JSON.parse(localWishlist) : {};
              var remoteWishlistData = JSON.parse(wishlistJsonData.innerHTML).wishlist || {};
              var bothWishlistEmpty = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(localWishlistData) && (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(remoteWishlistData);
              var onlyLocalWishlistEmpty = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(localWishlistData) && !(0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(remoteWishlistData);
              var onlyRemoteWishlistEmpty = !(0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(localWishlistData) && (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.isWishlistEmpty)(remoteWishlistData);
              switch (true) {
                case bothWishlistEmpty:
                  {
                    (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.createWishlist)();
                    break;
                  }
                case onlyLocalWishlistEmpty:
                  {
                    (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.createWishlist)(remoteWishlistData);
                    break;
                  }
                case onlyRemoteWishlistEmpty:
                  {
                    (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.updateRemoteWishlist)({
                      email: email,
                      wishlist: localWishlistData
                    });
                    break;
                  }
                case localWishlistData.lastUpdated !== remoteWishlistData.lastUpdated:
                  {
                    var combinedWishlist = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.combineWishlists)(localWishlistData, remoteWishlistData);
                    (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.createWishlist)(combinedWishlist);
                    (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.updateRemoteWishlist)({
                      email: email,
                      wishlist: combinedWishlist
                    });
                    break;
                  }
                default:
                  {
                    console.error('Something went wrong: Cannot initialize wishlist');
                  }
              }
            }
            if (!(0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.getWishlist)()) {
              (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.createWishlist)();
            }
            ctx.emit('wishlist:init');
          };
          updateWishlistHandler = function updateWishlistHandler(_ref2) {
            var variantId = _ref2.variantId,
              variantGroupId = _ref2.variantGroupId;
            return function (e) {
              ctx.emit('wishlist:update', null, {
                variantId: variantId,
                variantGroupId: variantGroupId
              });
              ctx.emit('wishlist:remove', null, {
                variantGroupId: variantGroupId
              });
              e.currentTarget.classList.remove('in-wishlist');
            };
          };
          updateTemplateHtml = function updateTemplateHtml(variant, clonedItemNode) {
            var _variant$productData;
            var _choozy2 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(clonedItemNode, null),
              image = _choozy2.image,
              discountLabel = _choozy2.discountLabel,
              discount = _choozy2.discount,
              customLabel = _choozy2.customLabel,
              title = _choozy2.title,
              priceElement = _choozy2.priceElement,
              compareAtPrice = _choozy2.compareAtPrice,
              price = _choozy2.price,
              link = _choozy2.link,
              colorSwatch = _choozy2.colorSwatch,
              sizeSelect = _choozy2.sizeSelect;
            image.src = variant.imageUrl;
            title.innerText = variant.title;
            link.href = "".concat(window.location.origin, "/products/").concat(variant.productHandle);
            var formattedPrice = new Intl.NumberFormat('de-DE', formatOptions).format(variant.price);
            price.innerText = "".concat(window.Phill.currency).concat(formattedPrice);
            colorSwatch.style.setProperty('--bg-color', variant.hexcode);
            if (variant.compareAtPrice) {
              priceElement.classList.add('is-success');
              var formattedComparePrice = new Intl.NumberFormat('de-DE', formatOptions).format(variant.compareAtPrice);
              compareAtPrice.innerText = "".concat(window.Phill.currency).concat(formattedComparePrice);
              discountLabel.classList.add('is-active');
              discount.innerText = Math.floor((variant.compareAtPrice - variant.price) * 100 / variant.compareAtPrice);
            } else if (variant.productLabel) {
              customLabel.innerText = variant.productLabel;
            }
            if ((_variant$productData = variant.productData) !== null && _variant$productData !== void 0 && (_variant$productData = _variant$productData.variants) !== null && _variant$productData !== void 0 && _variant$productData.length) {
              var fragment = document.createDocumentFragment();
              var overrideNames = sizeOverrides.replace(/\s/g, '').split(',').map(function (pair) {
                return pair.split(':');
              });
              variant.productData.variants.forEach(function (variantData) {
                var _overrideNames$find$, _overrideNames$find;
                if (!variantData.size) return;
                var option = document.createElement('option');
                option.value = variantData.id;
                var overrideName = (_overrideNames$find$ = (_overrideNames$find = overrideNames.find(function (pair) {
                  return variantData.size === pair[0];
                })) === null || _overrideNames$find === void 0 ? void 0 : _overrideNames$find[1]) !== null && _overrideNames$find$ !== void 0 ? _overrideNames$find$ : variantData.size;
                option.innerText = overrideName;
                option.selected = variantData.id.toString() === variant.id;
                option.dataset.available = variantData.isInStock;
                fragment.appendChild(option);
              });
              sizeSelect.appendChild(fragment);
            }
            clonedItemNode.dataset.productId = variant.productId;
            clonedItemNode.dataset.variantId = variant.id;
            clonedItemNode.dataset.variantGroupId = variant.groupId;
          };
          displayWishlistData = function displayWishlistData(productVariants) {
            var fragment = document.createDocumentFragment();
            productVariants.forEach(function (variant) {
              var clonedItemNode = wishlistItemTemplate.cloneNode(true).content.children[0];
              var _choozy3 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(clonedItemNode, null),
                addToWishlistBtn = _choozy3.addToWishlistBtn,
                sizeSelect = _choozy3.sizeSelect,
                sizeSelectContainer = _choozy3.sizeSelectContainer,
                submit = _choozy3.submit,
                submitText = _choozy3.submitText;
              updateTemplateHtml(variant, clonedItemNode);
              fragment.appendChild(clonedItemNode);
              var selectedVariant = variant.productData.variants.find(function (v) {
                return v.id.toString() === sizeSelect.value;
              });
              var onChangeSize = function onChangeSize() {
                var isComponentMounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                sizeSelectContainer.classList.add('is-selected');
                submit.removeAttribute('disabled');
                submitText.innerText = selectedVariant.isInStock ? (0,_lib_string__WEBPACK_IMPORTED_MODULE_0__.getString)('product.add_to_cart') : (0,_lib_string__WEBPACK_IMPORTED_MODULE_0__.getString)('product.notify_me');
                if (!isComponentMounted) return;
                emitVariantChange(_objectSpread(_objectSpread({}, selectedVariant), {}, {
                  productId: variant.productId
                }));
              };
              if (selectedVariant) {
                onChangeSize();
              }
              var onClickWishlistBtn = updateWishlistHandler({
                variantId: variant.id,
                variantGroupId: variant.groupId
              });
              addToWishlistBtn.addEventListener('click', onClickWishlistBtn);
              sizeSelect.addEventListener('change', function (e) {
                selectedVariant = variant.productData.variants.find(function (v) {
                  return v.id.toString() === e.target.value;
                });
                onChangeSize(true);
              });
            });
            wishlistGrid.appendChild(fragment);

            // Mount productForm component and update local data for each wishlist item
            window.app.mount();
            productVariants.forEach(function (variant) {
              var selectedVariant = variant.productData.variants.find(function (v) {
                return v.id.toString() === variant.id;
              });
              emitVariantChange(_objectSpread(_objectSpread({}, selectedVariant), {}, {
                productId: variant.productId
              }));
            });
          };
          displayFetchWishlistError = function displayFetchWishlistError(err) {
            wishlistContainer.classList.add('is-error');
            wishlistError.innerText = err;
          };
          getWishlistItems = /*#__PURE__*/function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variantIds) {
              var data;
              return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    if (variantIds) {
                      _context.next = 2;
                      break;
                    }
                    return _context.abrupt("return");
                  case 2:
                    wishlistContainer.classList.remove('is-error');
                    _context.prev = 3;
                    _context.next = 6;
                    return (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.fetchWishlistItems)(variantIds);
                  case 6:
                    data = _context.sent;
                    displayWishlistData(data.productVariants);
                    _context.next = 13;
                    break;
                  case 10:
                    _context.prev = 10;
                    _context.t0 = _context["catch"](3);
                    displayFetchWishlistError(_context.t0);
                  case 13:
                  case "end":
                    return _context.stop();
                }
              }, _callee, null, [[3, 10]]);
            }));
            return function getWishlistItems(_x3) {
              return _ref3.apply(this, arguments);
            };
          }();
          updateWishlistCount = function updateWishlistCount() {
            var wishlist = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.getWishlist)();
            var _JSON$parse = JSON.parse(wishlist),
              items = _JSON$parse.items;
            var itemsInWishlist = Object.values(items).filter(function (item) {
              return item.inWishlist;
            }).length;
            if (!wishlistCount) return;
            wishlistCount.innerText = itemsInWishlist;
          };
          removeFromWishlistGrid = function removeFromWishlistGrid(variantId) {
            var _choozy4 = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null),
              wishlistItem = _choozy4.wishlistItem;
            var selectedWishlistItem = wishlistItem && [].concat(wishlistItem).find(function (item) {
              return item.dataset.variantId === variantId.toString();
            });
            selectedWishlistItem && selectedWishlistItem.remove();
          };
          initWishlist();
          updateWishlistCount();
          ctx.on('wishlist:open', function () {
            node.classList.add('is-active');
            document.body.classList.add('overflow-hidden');
          });
          [backLayer, wishlistCloseBtn].forEach(function (elem) {
            return elem.addEventListener('click', function () {
              node.classList.remove('is-active');
              document.body.classList.remove('overflow-hidden');
            });
          });
          ctx.on('wishlist:update', function (_, _ref4) {
            var variantId = _ref4.variantId,
              variantGroupId = _ref4.variantGroupId;
            var wishlist = (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.getWishlist)();
            var wishlistData = JSON.parse(wishlist);
            var timestamp = Date.now();
            wishlistData.lastUpdated = timestamp;
            var foundVariantKey = Object.keys(wishlistData.items).find(function (itemKey) {
              return itemKey === variantGroupId;
            });
            wishlistData.items[variantGroupId] = {
              inWishlist: foundVariantKey ? !wishlistData.items[variantGroupId].inWishlist : true,
              updatedAt: timestamp,
              variantId: variantId.toString()
            };
            (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.createWishlist)(wishlistData);
            updateWishlistCount();
            wishlistData.items[variantGroupId].inWishlist ? getWishlistItems([variantId]) : removeFromWishlistGrid(variantId);
            ctx.emit('wishlist:changed', null, {
              isInWishlist: wishlistData.items[variantGroupId].inWishlist
            });
            if (window.Phill.customer.email) {
              (0,_lib_wishlist_util__WEBPACK_IMPORTED_MODULE_2__.updateRemoteWishlist)({
                wishlist: wishlistData,
                email: window.Phill.customer.email
              });
            }
          });
          getWishlistItems([]);
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/product/main-product.js":
/*!****************************************************!*\
  !*** ./scripts/components/product/main-product.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/get-style-var-value */ "./scripts/lib/get-style-var-value.js");
/* harmony import */ var _lib_waitToLoad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/waitToLoad */ "./scripts/lib/waitToLoad.js");
/* harmony import */ var _lib_is_different_variant__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/is-different-variant */ "./scripts/lib/is-different-variant.js");
/* harmony import */ var _util_wheelcontrols__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../util/wheelcontrols */ "./scripts/util/wheelcontrols.js");
/* harmony import */ var _util_photoswipe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../util/photoswipe */ "./scripts/util/photoswipe.js");
/* harmony import */ var _util_photoswipe_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../util/photoswipe.css */ "./scripts/util/photoswipe.css");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable no-param-reassign */







var getTranslate3d = function getTranslate3d(el) {
  if (el.style.transform.length === 0) return {
    x: 0,
    y: 0,
    z: 0
  };
  var values = el.style.transform.split(/\w+\(|\);?/);
  if (!values[1] || !values[1].length) {
    return [];
  }
  var transform = values[1].split(/,\s?/g);
  return {
    x: parseInt(transform[0]),
    y: parseInt(transform[1]),
    z: parseInt(transform[2])
  };
};
var disableScrolling = function disableScrolling(element) {
  var x = element.scrollX;
  var y = element.scrollY;
  element.style.overflow = 'hidden';
  element.onscroll = function () {
    element.scrollTo(x, y);
  };
};
var enableScrolling = function enableScrolling(element) {
  element.style.overflow = 'scroll';
  element.onscroll = function () {};
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node, ctx) {
    var _choozy, colorPlaceholder, image, container, pdpInfo, swipeIndicator, toggleContainer, sizeSelectButton, sizeGuideToggle, colorSlider, colorSlide, isDown, position, startY, oldTransform, canDrag, isActive, updateMobileInfoTopOffset, initializeGallery, initializeGalleryMobile, onChangePdpOffset, setTranslateValue, containerScroll, onUpdatePdpInfoPosition, keenSlider, dataColorSlides;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null), colorPlaceholder = _choozy.colorPlaceholder, image = _choozy.image, container = _choozy.container, pdpInfo = _choozy.pdpInfo, swipeIndicator = _choozy.swipeIndicator, toggleContainer = _choozy.toggleContainer, sizeSelectButton = _choozy.sizeSelectButton, sizeGuideToggle = _choozy.sizeGuideToggle, colorSlider = _choozy.colorSlider, colorSlide = _choozy.colorSlide;
          if (!colorSlider) {
            _context.next = 5;
            break;
          }
          _context.next = 4;
          return (0,_lib_waitToLoad__WEBPACK_IMPORTED_MODULE_2__["default"])('Keen slider');
        case 4:
          // Keen slider has loaded, remove default styling
          if (colorSlide) {
            [].concat(colorSlide).forEach(function (slide) {
              slide.classList.remove('mr-[0.8rem]');
            });
          }
        case 5:
          isDown = false;
          position = 0; // position is supposed to be opened or closed
          canDrag = true;
          isActive = false;
          updateMobileInfoTopOffset = function updateMobileInfoTopOffset() {
            // this function determines the height of the pdp info
            // it is used to create an offset, by subtraction from window.innerHeight, for the top property of the node element when the panel is opened to the max
            var infoHeight = (0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(pdpInfo, '--content-offset');
            var swipeIndicatorHeight = swipeIndicator.offsetHeight;
            var height = "".concat(infoHeight + swipeIndicatorHeight, "px");
            node.style.setProperty('--mobile-info-visible', height);
            node.classList.add('pdp-loaded');
          };
          initializeGallery = function initializeGallery() {
            var lightbox = new _util_photoswipe__WEBPACK_IMPORTED_MODULE_5__["default"]({
              gallery: '#mainGallery',
              children: 'a',
              arrowPrev: false,
              arrowNext: false,
              zoom: false,
              close: false,
              counter: false,
              pswpModule: function pswpModule() {
                return __webpack_require__.e(/*! import() */ "scripts_util_photoswipe_esm_js").then(__webpack_require__.bind(__webpack_require__, /*! ../../util/photoswipe.esm.js */ "./scripts/util/photoswipe.esm.js"));
              }
            });
            lightbox.on('uiRegister', function () {
              lightbox.pswp.ui.registerElement({
                name: 'previous-button',
                className: 'circle-button ',
                ariaLabel: 'Toggle prev',
                order: 1,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon icon--direction-aware\" viewBox=\"0 0 16 18\">\n          <path d=\"M11 1 3 9l8 8\" stroke=\"currentColor\" stroke-linecap=\"square\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightbox.pswp.prev();
                }
              });
            });
            lightbox.on('uiRegister', function () {
              lightbox.pswp.ui.registerElement({
                name: 'next-button',
                className: 'circle-button ',
                ariaLabel: 'Toggle next',
                order: 3,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon icon--direction-aware\" viewBox=\"0 0 16 18\">\n          <path d=\"m5 17 8-8-8-8\" stroke=\"currentColor\" stroke-linecap=\"square\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightbox.pswp.next();
                }
              });
            });
            lightbox.on('uiRegister', function () {
              lightbox.pswp.ui.registerElement({
                name: 'close-button',
                className: 'circle-button circle-button--xl ',
                ariaLabel: 'Toggle close',
                order: 2,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon\" viewBox=\"0 0 16 16\">\n          <path d=\"m1 1 14 14M1 15 15 1\" stroke=\"currentColor\" stroke-width=\"1\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightbox.pswp.close();
                }
              });
            });
            lightbox.init();
            console.log('light'.lightbox);
          };
          initializeGalleryMobile = function initializeGalleryMobile() {
            document.querySelector('#mobileGallery').addEventListener('click', function () {
              console.log('clicked! tes');
            });
            console.log("consolemobiletest");
            var lightboxMobile = new _util_photoswipe__WEBPACK_IMPORTED_MODULE_5__["default"]({
              gallery: '#mobileGallery',
              children: 'a',
              arrowPrev: false,
              arrowNext: false,
              zoom: false,
              close: false,
              counter: false,
              pswpModule: function pswpModule() {
                return __webpack_require__.e(/*! import() */ "scripts_util_photoswipe_esm_js").then(__webpack_require__.bind(__webpack_require__, /*! ../../util/photoswipe.esm.js */ "./scripts/util/photoswipe.esm.js"));
              }
            });
            lightboxMobile.on('uiRegister', function () {
              lightboxMobile.pswp.ui.registerElement({
                name: 'previous-button',
                className: 'circle-button ',
                ariaLabel: 'Toggle prev',
                order: 1,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon icon--direction-aware\" viewBox=\"0 0 16 18\">\n          <path d=\"M11 1 3 9l8 8\" stroke=\"currentColor\" stroke-linecap=\"square\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightboxMobile.pswp.prev();
                }
              });
            });
            lightboxMobile.on('uiRegister', function () {
              lightboxMobile.pswp.ui.registerElement({
                name: 'next-button',
                className: 'circle-button ',
                ariaLabel: 'Toggle next',
                order: 3,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon icon--direction-aware\" viewBox=\"0 0 16 18\">\n          <path d=\"m5 17 8-8-8-8\" stroke=\"currentColor\" stroke-linecap=\"square\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightboxMobile.pswp.next();
                }
              });
            });
            lightboxMobile.on('uiRegister', function () {
              lightboxMobile.pswp.ui.registerElement({
                name: 'close-button',
                className: 'circle-button circle-button--xl ',
                ariaLabel: 'Toggle close',
                order: 2,
                isButton: true,
                html: "\n        <svg aria-hidden=\"true\" focusable=\"false\" fill=\"none\" width=\"16\" class=\"icon\" viewBox=\"0 0 16 16\">\n          <path d=\"m1 1 14 14M1 15 15 1\" stroke=\"currentColor\" stroke-width=\"1\"/>\n        </svg>\n      ",
                onClick: function onClick(event, el) {
                  lightboxMobile.pswp.close();
                }
              });
            });
            lightboxMobile.init();
            console.log('lightMob', lightboxMobile);
          };
          initializeGalleryMobile();
          initializeGallery();
          onChangePdpOffset = function onChangePdpOffset(variant) {
            // this function updates the content offset to determine the height of the initial, closed panel
            var currentOffset = (0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(node, '--content-offset');
            var offset = variant ? variant.compare_at_price ? '165px' : '125px' : currentOffset;
            node.style.setProperty('--content-offset', offset);
          };
          setTranslateValue = function setTranslateValue(element, value) {
            // Used to set the translateY value for the pdp-info element
            element.style.transform = "translate3d(0px, -".concat(value, "px, 0px)");
          };
          ctx.on('variant:change', function (_, _ref2) {
            var product = _ref2.product,
              selectedVariant = _ref2.selectedVariant,
              isWishlistItem = _ref2.isWishlistItem;
            if ((0,_lib_is_different_variant__WEBPACK_IMPORTED_MODULE_3__["default"])({
              productId: product.id.toString(),
              data: node.dataset,
              isWishlistItem: isWishlistItem
            })) return;
            var imageList = image ? [].concat(image) : [];
            imageList.forEach(function (eachImage) {
              eachImage.classList[eachImage.dataset.variant === selectedVariant.option1 ? 'remove' : 'add']('hidden-tw');
            });
            if (colorPlaceholder) colorPlaceholder.innerHTML = selectedVariant.option1;
          });
          if (window.innerWidth <= 1024) {
            // Disable scroll on the body on mobile
            // Added custom code to body.js ensure body height = window.innerHeight and overflowY = hidden
            document.body.style.height = "".concat(window.innerHeight, "px");
            document.body.style.overflow = 'hidden';
            disableScrolling(container); // disable scrolling because translation needs to take place

            node.style.height = "".concat(window.innerHeight, "px");
            container.style.height = "".concat(window.innerHeight, "px"); // height of the entire container

            pdpInfo.addEventListener('touchstart', function (e) {
              pdpInfo.classList.remove('is-active'); // remove transition from pdp-info
              isDown = true;
              oldTransform = getTranslate3d(pdpInfo).y;
              startY = e.changedTouches[0].pageY - getTranslate3d(pdpInfo).y;
            });
            containerScroll = function containerScroll() {
              canDrag = container.scrollTop <= 30 && !isActive; // isActive means touch-moving
            };
            container.addEventListener('scroll', containerScroll, {
              passive: true
            });
            pdpInfo.addEventListener('touchend', function () {
              pdpInfo.classList.add('is-active');
              enableScrolling(container);
              var dragged = oldTransform - getTranslate3d(pdpInfo).y;
              var translateY;

              // STAY OPEN:
              // when pdp-info is closed, when you drag up more than 70px, it will open
              // when pdp-info is opened, when you drag down less than 70px, it will stay open
              if (position === 0 && dragged >= 70 || position === 1 && dragged > -70) {
                ctx.emit('mobilePdpUp', function () {
                  return {
                    mobilePdpUp: true
                  };
                });
                container.classList.add('mobile-info-open');
                enableScrolling(container);
                position = 1;

                // get to the top of the page
                translateY = window.innerHeight - (0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(node, '--mobile-info-visible') + swipeIndicator.offsetHeight;

                // STAY CLOSED:
              } else if (position === 0 && dragged <= 70 || position === 1 && dragged <= -70) {
                ctx.emit('mobilePdpUp', function () {
                  return {
                    mobilePdpUp: false
                  };
                });
                container.classList.remove('mobile-info-open');
                disableScrolling(container);
                position = 0;
                // get to the bottom of the page
                translateY = 0;
              }
              setTranslateValue(pdpInfo, translateY);
              isDown = false;
              isActive = false;
            }, {
              passive: true
            });
            pdpInfo.addEventListener('touchmove', function (e) {
              isActive = true;
              if (!isDown) return;
              if (container.scrollTop <= 5 && canDrag === true) {
                if (position === 0) {
                  e.preventDefault();
                }
                var x = e.changedTouches[0].pageY;
                var walk = x - startY;
                if (position === 1 && walk <= oldTransform) return;
                disableScrolling(container);
                var maxWalk = -Math.abs(window.innerHeight - ((0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(node, '--mobile-info-visible') - swipeIndicator.offsetHeight));
                if (walk < maxWalk) return;
                if (Math.sign(walk) === 1) return;
                pdpInfo.style.transform = "translate3d(0px, ".concat(walk, "px, 0px)");
              }
            });

            // Slide draggable product info in to view
            setTimeout(function () {
              updateMobileInfoTopOffset();
            }, 500);
            if (toggleContainer) toggleContainer.addEventListener('click', function () {
              container.classList.remove('mobile-info-open');
              ctx.emit('mobilePdpUp', function () {
                return {
                  mobilePdpUp: false
                };
              });
              ctx.emit('mobile-pdp:close', {
                sizeSelectOpen: false
              });
              disableScrolling(container);
              setTranslateValue(pdpInfo, 0);
              position = 0;
            });
            ctx.on('mobilePdpUp', function (_ref3) {
              var mobilePdpUp = _ref3.mobilePdpUp;
              toggleContainer.classList[mobilePdpUp ? 'add' : 'remove']('mobile-info-open');
              sizeSelectButton.classList[mobilePdpUp ? 'add' : 'remove']('mobile-info-open');
              container.classList[mobilePdpUp ? 'add' : 'remove']('mobile-open');
            });
            sizeSelectButton.addEventListener('click', function () {
              ctx.emit('toggleSizeSelect', function () {
                return {
                  sizeSelectOpen: true
                };
              });
            });
            onUpdatePdpInfoPosition = function onUpdatePdpInfoPosition(mobilePdpUp, variant) {
              // this function is called when the variant is changed
              // it is used to update 1. the height of the mobile info when closed and 2. the offset for the mobile info when open
              onChangePdpOffset(variant);
              updateMobileInfoTopOffset();
              if (mobilePdpUp) {
                // remove transition while changing the positioning
                pdpInfo.classList.remove('is-active');
                var translateY = window.innerHeight - (0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(node, '--mobile-info-visible') + swipeIndicator.offsetHeight;
                setTranslateValue(pdpInfo, translateY);
                setTimeout(function () {
                  pdpInfo.classList.add('is-active');
                });
              }
            };
            ctx.on(['variant:change'], function (_ref4, _ref5) {
              var mobilePdpUp = _ref4.mobilePdpUp;
              var product = _ref5.product,
                selectedVariant = _ref5.selectedVariant,
                isWishlistItem = _ref5.isWishlistItem;
              if ((0,_lib_is_different_variant__WEBPACK_IMPORTED_MODULE_3__["default"])({
                productId: product.id.toString(),
                data: node.dataset,
                isWishlistItem: isWishlistItem
              })) return;
              onUpdatePdpInfoPosition(mobilePdpUp, selectedVariant);
            });

            // Slide draggable product info in to view
            setTimeout(function () {
              node.classList.add('pdp-loaded');
            }, 100);
          }
          keenSlider = new KeenSlider(colorSlider, {
            rubberband: false,
            slides: {
              perView: 5.3,
              spacing: '8'
            }
          }, [_util_wheelcontrols__WEBPACK_IMPORTED_MODULE_4__["default"]]); // ON COLOR VARIANTS SELECT CLOSE THE MOBILE POPUP ON
          dataColorSlides = document.querySelectorAll('[data-color-slide]');
          if (dataColorSlides.length > 0 && window.innerWidth < 768) {
            dataColorSlides.forEach(function (slide) {
              slide.addEventListener('click', function () {
                container.classList.remove('mobile-info-open'); // Close the menu
                ctx.emit('mobilePdpUp', function () {
                  return {
                    mobilePdpUp: false
                  };
                });
                ctx.emit('mobile-pdp:close', {
                  sizeSelectOpen: false
                });
                disableScrolling(container);
                setTranslateValue(pdpInfo, 0);
                position = 0;
              });
            });
          }
        case 21:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/product/product-form.js":
/*!****************************************************!*\
  !*** ./scripts/components/product/product-form.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/cart */ "./scripts/lib/cart.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_is_different_variant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/is-different-variant */ "./scripts/lib/is-different-variant.js");
/* harmony import */ var _lib_string__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/string */ "./scripts/lib/string.js");
/* harmony import */ var _lib_subscribe_to_notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../lib/subscribe-to-notifications */ "./scripts/lib/subscribe-to-notifications.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* eslint-disable no-prototype-builtins */





var emailRegEx = new RegExp(/\S+@\S+\.\S+/);
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _document$querySelect, _sizeChartBtn$dataset;
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null),
    submit = _choozy.submit,
    submitText = _choozy.submitText,
    notifyEmail = _choozy.notifyEmail,
    notifyMeBtn = _choozy.notifyMeBtn,
    sizeChartBtn = _choozy.sizeChartBtn;
  var currentVariant = null;
  ctx.on('variant:change', function (_, _ref) {
    var product = _ref.product,
      selectedVariant = _ref.selectedVariant,
      _ref$isWishlistItem = _ref.isWishlistItem,
      isWishlistItem = _ref$isWishlistItem === void 0 ? false : _ref$isWishlistItem;
    if ((0,_lib_is_different_variant__WEBPACK_IMPORTED_MODULE_2__["default"])({
      productId: product.id.toString(),
      data: node.dataset,
      isWishlistItem: isWishlistItem
    })) return;
    currentVariant = selectedVariant;
  });
  var addToCart = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(variant) {
      var _yield$addVariant, error;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            submit.disabled = true;
            submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.adding_to_cart');
            _context.next = 4;
            return (0,_lib_cart__WEBPACK_IMPORTED_MODULE_0__.addVariant)(variant, 1);
          case 4:
            _yield$addVariant = _context.sent;
            error = _yield$addVariant.error;
            // eslint-disable-next-line no-alert
            if (error) alert(error);
            submit.disabled = true;
            submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.added_to_cart');
            ctx.emit('quick-add:success');
            setTimeout(function () {
              if (!error) ctx.emit('cart:toggle', {
                cartOpen: true
              });
            }, 0);
            setTimeout(function () {
              submit.disabled = false;
              submitText.textContent = (0,_lib_string__WEBPACK_IMPORTED_MODULE_3__.getString)('product.add_to_cart');
            }, error ? 0 : 1000);
          case 12:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function addToCart(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var openNotifyForm = function openNotifyForm() {
    notifyMeBtn.disabled = true;
    node.classList.add('is-visible');
  };
  var closeNotifyForm = function closeNotifyForm() {
    notifyMeBtn.disabled = false;
    notifyEmail.value = '';
    node.classList.remove('is-visible', 'is-success');
  };
  notifyEmail.addEventListener('input', function (e) {
    var value = e.target.value;
    var isValid = value && node.classList.contains('is-visible') && emailRegEx.test(value);
    notifyMeBtn.disabled = !isValid;
  });
  notifyMeBtn.addEventListener('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return (0,_lib_subscribe_to_notifications__WEBPACK_IMPORTED_MODULE_4__["default"])(notifyEmail.value, currentVariant.id);
        case 3:
          node.classList.add('is-success');
          setTimeout(closeNotifyForm, 1500);
          _context2.next = 10;
          break;
        case 7:
          _context2.prev = 7;
          _context2.t0 = _context2["catch"](0);
          console.error(_context2.t0);
        case 10:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 7]]);
  })));
  var onOpenNotifyForm = function onOpenNotifyForm() {
    openNotifyForm();
    if (!currentVariant.option2) return;
    ctx.emit('size-modal:update', null, {
      size: currentVariant.option2
    });
  };
  node.addEventListener('submit', function (e) {
    e.preventDefault();
    if (currentVariant.available) {
      addToCart(currentVariant);
      return;
    }
    if (!node.classList.contains('is-visible')) {
      onOpenNotifyForm();
    }
  });
  ctx.on(['toggleSizeSelect', 'mobile-pdp:close', 'quick-add:close'], function (_ref4) {
    var sizeSelectOpen = _ref4.sizeSelectOpen;
    if (!sizeSelectOpen) {
      setTimeout(function () {
        ctx.emit('size-modal:update', null, {
          size: null
        });
        closeNotifyForm();
      }, 300);
    }
  });

  /**
   * Size chart button
   */
  var sizeChartTypes = ((_document$querySelect = document.querySelector('#size-chart')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.dataset) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.chartTypes) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.split(',')) || [];
  var productTags = (sizeChartBtn === null || sizeChartBtn === void 0 || (_sizeChartBtn$dataset = sizeChartBtn.dataset) === null || _sizeChartBtn$dataset === void 0 || (_sizeChartBtn$dataset = _sizeChartBtn$dataset.productTags) === null || _sizeChartBtn$dataset === void 0 ? void 0 : _sizeChartBtn$dataset.split(',')) || [];
  var chartType = productTags.find(function (tag) {
    return sizeChartTypes.includes(tag);
  });
  if (chartType) {
    sizeChartBtn.style.visibility = 'visible';
    sizeChartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      ctx.emit('sizeChartToggle', function (_ref5) {
        var showSizeChart = _ref5.showSizeChart,
          sizeChartType = _ref5.sizeChartType;
        return {
          showSizeChart: true,
          sizeChartType: chartType
        };
      });
    });
  }
}));

/***/ }),

/***/ "./scripts/components/product/product-selection.js":
/*!*********************************************************!*\
  !*** ./scripts/components/product/product-selection.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_update_prices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/update-prices */ "./scripts/lib/update-prices.js");
/* harmony import */ var _lib_update_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/update-sizes */ "./scripts/lib/update-sizes.js");
/* harmony import */ var _lib_update_details__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../lib/update-details */ "./scripts/lib/update-details.js");
/* harmony import */ var _lib_update_discount__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../lib/update-discount */ "./scripts/lib/update-discount.js");
/* harmony import */ var _lib_updateWishlist__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../lib/updateWishlist */ "./scripts/lib/updateWishlist.js");
/* harmony import */ var _lib_update_submit_text__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../lib/update-submit-text */ "./scripts/lib/update-submit-text.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_set_url_params__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../lib/set-url-params */ "./scripts/lib/set-url-params.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */








/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_6__["default"])(node, null),
    productJson = _choozy.productJson,
    addToWishlistBtn = _choozy.addToWishlistBtn,
    sizeInput = _choozy.sizeInput;
  var _JSON$parse = JSON.parse(productJson.innerHTML),
    product = _JSON$parse.product,
    defaultVariant = _JSON$parse.defaultVariant,
    defaultVariantGroupId = _JSON$parse.defaultVariantGroupId;
  var currentVariant = _objectSpread(_objectSpread({}, defaultVariant), {}, {
    variantGroupId: defaultVariantGroupId
  });
  ctx.emit('variant:change', null, {
    product: product,
    selectedVariant: _objectSpread(_objectSpread({}, defaultVariant), {}, {
      variantGroupId: defaultVariantGroupId
    })
  });
  var sizeInputList = sizeInput ? [].concat(sizeInput) : [];
  var getSelectedSizeId = function getSelectedSizeId(color) {
    return sizeInputList.find(function (input) {
      return input.checked && input.dataset.color === color;
    }).dataset.variantId;
  };
  ctx.on('wishlist:init', function () {
    (0,_lib_updateWishlist__WEBPACK_IMPORTED_MODULE_4__["default"])(defaultVariantGroupId, addToWishlistBtn);
  });
  var onVariantChange = function onVariantChange(data) {
    var sizeVariantId = data.variantId,
      variantGroupId = data.variantGroupId,
      colorInput = data.colorInput;
    var variantId = colorInput ? getSelectedSizeId(colorInput) : sizeVariantId;
    var selectedVariant = product.variants.find(function (v) {
      return v.id.toString() === variantId;
    });
    currentVariant = _objectSpread(_objectSpread({}, selectedVariant), {}, {
      variantGroupId: variantGroupId
    });
    (0,_lib_updateWishlist__WEBPACK_IMPORTED_MODULE_4__["default"])(variantGroupId, addToWishlistBtn);
    (0,_lib_update_prices__WEBPACK_IMPORTED_MODULE_0__["default"])(selectedVariant, node);
    (0,_lib_update_sizes__WEBPACK_IMPORTED_MODULE_1__["default"])(selectedVariant, node);
    (0,_lib_update_details__WEBPACK_IMPORTED_MODULE_2__["default"])(selectedVariant, node);
    (0,_lib_update_discount__WEBPACK_IMPORTED_MODULE_3__["default"])(selectedVariant, node);
    (0,_lib_update_submit_text__WEBPACK_IMPORTED_MODULE_5__["default"])(selectedVariant, node);
    (0,_lib_set_url_params__WEBPACK_IMPORTED_MODULE_7__["default"])([{
      name: 'variant',
      value: variantId
    }]);
    ctx.emit('variant:change', null, {
      product: product,
      selectedVariant: _objectSpread(_objectSpread({}, selectedVariant), {}, {
        variantGroupId: variantGroupId
      })
    });
  };
  node.addEventListener('change', function (e) {
    return onVariantChange(e.target.dataset);
  });
  ctx.on('variant-color:change', function (_, data) {
    if (!product.variants.find(function (v) {
      return v.id.toString() === data.variantId;
    })) return;
    onVariantChange(data);
  });
  addToWishlistBtn === null || addToWishlistBtn === void 0 || addToWishlistBtn.addEventListener('click', function (e) {
    ctx.emit('wishlist:update', null, {
      variantId: currentVariant.id,
      variantGroupId: currentVariant.variantGroupId
    });
    e.currentTarget.classList.toggle('in-wishlist');
  });
}));

/***/ }),

/***/ "./scripts/components/product/size-select-modal.js":
/*!*********************************************************!*\
  !*** ./scripts/components/product/size-select-modal.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/get-style-var-value */ "./scripts/lib/get-style-var-value.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node, ctx) {
    var _choozy, sizeSelectModal, sizeSelectClose, infoSize, sizeSelectOverlay, sizeSelectContainer, contentOffset;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null), sizeSelectModal = _choozy.sizeSelectModal, sizeSelectClose = _choozy.sizeSelectClose, infoSize = _choozy.infoSize, sizeSelectOverlay = _choozy.sizeSelectOverlay, sizeSelectContainer = _choozy.sizeSelectContainer;
          if (window.innerWidth <= 1024) {
            // offset due to pdp slide up feature adjustments
            contentOffset = (0,_lib_get_style_var_value__WEBPACK_IMPORTED_MODULE_1__["default"])(document.querySelector('[data-pdp-info]'), '--content-offset');
            sizeSelectOverlay.style.top = "calc(-100% + ".concat(contentOffset, "px)");
            sizeSelectContainer.style.bottom = "calc(100% - ".concat(contentOffset, "px)");
            ctx.on('toggleSizeSelect', function (_ref2) {
              var sizeSelectOpen = _ref2.sizeSelectOpen;
              [].concat(sizeSelectModal).forEach(function (each) {
                each.classList[sizeSelectOpen ? 'add' : 'remove']('size-select-open');
              });
            });
            [].concat(sizeSelectClose).forEach(function (each) {
              each.addEventListener('click', function () {
                ctx.emit('toggleSizeSelect', function () {
                  return {
                    sizeSelectOpen: false
                  };
                });
              });
            });
          }
          ctx.on('size-modal:update', function (_, _ref3) {
            var size = _ref3.size;
            infoSize.innerText = size;
          });
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/sections/category-slider.js":
/*!********************************************************!*\
  !*** ./scripts/components/sections/category-slider.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/waitToLoad */ "./scripts/lib/waitToLoad.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _util_wheelcontrols__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/wheelcontrols */ "./scripts/util/wheelcontrols.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node) {
    var _choozy, slider, rightArrow, slide, sliderInit;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null), slider = _choozy.slider, rightArrow = _choozy.rightArrow, slide = _choozy.slide;
          _context.next = 3;
          return (0,_lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__["default"])('Keen slider');
        case 3:
          // Remove keen slider default styling
          [].concat(slide).forEach(function (slide) {
            slide.classList.remove('mr-[1.2rem]');
          });
          sliderInit = new KeenSlider(slider, {
            breakpoints: {
              '(min-width: 768px)': {
                slides: {
                  perView: 3.5,
                  spacing: 12,
                  origin: 'center'
                }
              },
              '(min-width: 1440px)': {
                slides: {
                  perView: 4,
                  spacing: 12,
                  origin: 'center'
                }
              }
            },
            slides: {
              perView: 1.5,
              spacing: 12,
              origin: 'center'
            },
            loop: true
          }, [_util_wheelcontrols__WEBPACK_IMPORTED_MODULE_2__["default"]]);
          rightArrow.addEventListener('click', function () {
            sliderInit.next();
          });
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/sections/components.js":
/*!***************************************************!*\
  !*** ./scripts/components/sections/components.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _category_slider__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./category-slider */ "./scripts/components/sections/category-slider.js");
/* harmony import */ var _instagram_slider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./instagram-slider */ "./scripts/components/sections/instagram-slider.js");
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./stores */ "./scripts/components/sections/stores.js");
/* harmony import */ var _media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./media */ "./scripts/components/sections/media.js");
/* harmony import */ var _main_blog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./main-blog */ "./scripts/components/sections/main-blog.js");
/* harmony import */ var _shop_the_look__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./shop-the-look */ "./scripts/components/sections/shop-the-look.js");
/* harmony import */ var _shop_the_pop_up__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./shop-the-pop-up */ "./scripts/components/sections/shop-the-pop-up.js");
/* harmony import */ var _section_dropdown__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./section-dropdown */ "./scripts/components/sections/section-dropdown.js");








/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
  categorySlider: _category_slider__WEBPACK_IMPORTED_MODULE_0__["default"],
  instagramSlider: _instagram_slider__WEBPACK_IMPORTED_MODULE_1__["default"],
  stores: _stores__WEBPACK_IMPORTED_MODULE_2__["default"],
  media: _media__WEBPACK_IMPORTED_MODULE_3__["default"],
  mainBlog: _main_blog__WEBPACK_IMPORTED_MODULE_4__["default"],
  shopTheLook: _shop_the_look__WEBPACK_IMPORTED_MODULE_5__["default"],
  shopThePopUp: _shop_the_pop_up__WEBPACK_IMPORTED_MODULE_6__["default"],
  sectionDropdown: _section_dropdown__WEBPACK_IMPORTED_MODULE_7__["default"]
});

/***/ }),

/***/ "./scripts/components/sections/instagram-slider.js":
/*!*********************************************************!*\
  !*** ./scripts/components/sections/instagram-slider.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/waitToLoad */ "./scripts/lib/waitToLoad.js");
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _util_wheelcontrols__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../util/wheelcontrols */ "./scripts/util/wheelcontrols.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node) {
    var _choozy, instagramSlider, sliderInit;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0,_lib_waitToLoad__WEBPACK_IMPORTED_MODULE_0__["default"])('Keen slider');
        case 2:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_1__["default"])(node, null), instagramSlider = _choozy.instagramSlider;
          sliderInit = new KeenSlider(instagramSlider, {
            slides: {
              perView: 1.9,
              spacing: 12,
              origin: 'center'
            },
            breakpoints: {
              '(min-width: 768px)': {
                slides: {
                  perView: 2.5,
                  spacing: 12,
                  origin: 'center'
                }
              },
              '(min-width: 1024px)': {
                slides: {
                  perView: 4,
                  spacing: 12,
                  origin: 'center'
                }
              }
            },
            loop: true
          }, [_util_wheelcontrols__WEBPACK_IMPORTED_MODULE_2__["default"]]);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/components/sections/main-blog.js":
/*!**************************************************!*\
  !*** ./scripts/components/sections/main-blog.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var PERPAGELIMIT = 6;
var fetchHtml = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(url) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", fetch(url).then(function (response) {
            return response.text();
          }).then(function (responseText) {
            return new DOMParser().parseFromString(responseText, 'text/html');
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchHtml(_x) {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var el = node;
  var section;
  var currentPage = 1;
  if (node.dataset.blogCount >= PERPAGELIMIT) {
    section = {
      articleGrid: '[data-article-grid]',
      button: '[data-load-more-articles]'
    };
    el.querySelector(section.button).addEventListener('click', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var articlesHtmlRender;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            el.querySelector('.placeholder-tile').remove();
            currentPage++;
            _context2.next = 4;
            return fetchHtml("".concat(window.location.origin + window.location.pathname, "?page=").concat(currentPage));
          case 4:
            articlesHtmlRender = _context2.sent;
            if (Math.ceil(node.dataset.blogCount / PERPAGELIMIT) === currentPage) {
              el.querySelector(section.button).remove();
            }
            window.app.emit(['articles:render'], {
              html: articlesHtmlRender
            });
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
  }
  ctx.on('articles:render', function (_ref3) {
    var html = _ref3.html;
    el.querySelector(section.articleGrid).innerHTML += html.querySelector(section.articleGrid).innerHTML;
  });
}));

/***/ }),

/***/ "./scripts/components/sections/media.js":
/*!**********************************************!*\
  !*** ./scripts/components/sections/media.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
/* eslint-disable no-unused-expressions */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  // on click - play video; hide play button; set controls attr
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    videoDesktop = _choozy.videoDesktop,
    videoMobile = _choozy.videoMobile,
    playOverlay = _choozy.playOverlay;
  var videoToPlay = window.innerWidth < 1024 ? videoMobile : videoDesktop;
  if (playOverlay) {
    playOverlay.addEventListener('click', function () {
      if (videoToPlay) {
        videoToPlay.load();
        // TODO: check images normal work; put comments under image to indicate placeholder for video
        playOverlay.style.visibility = 'hidden';
        videoToPlay.play();
      }
    });
  }

  // const hideOverlay = () => {
  //   playButton.remove();
  //   placeholderImage && placeholderImage.classList.add('hidden-tw');
  // };

  // const showVideo = video => {
  //   video.load();
  //   video.play();
  // };

  // const playVideo = video => {
  //   if (!video) {
  //     return;
  //   }

  //   node.addEventListener('click', e => {
  //     if (e.target.nodeName !== 'VIDEO' && e.target.nodeName !== 'SECTION') {
  //       hideOverlay();
  //       showVideo(video);
  //     }
  //   });
  // };

  // const videoToPlay = window.innerWidth < 1024 ? videoMobile : videoDesktop;
  // playVideo(videoToPlay);
}));

/***/ }),

/***/ "./scripts/components/sections/section-dropdown.js":
/*!*********************************************************!*\
  !*** ./scripts/components/sections/section-dropdown.js ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    toggle = _choozy.toggle;
  var toggles = toggle ? [].concat(toggle) : [];
  var sections = document.querySelectorAll('[data-section]');
  toggles.forEach(function (t) {
    t.addEventListener('click', function (e) {
      var target = t.dataset.target;
      toggles.forEach(function (t) {
        t.classList.remove('is-active');
      });
      e.target.classList.add('is-active');
      sections.forEach(function (section) {
        var sectionTarget = section.dataset.sectionTarget;
        if (target === sectionTarget) {
          section.classList.add('is-active');
        } else {
          section.classList.remove('is-active');
        }
      });
    });
  });
}));

/***/ }),

/***/ "./scripts/components/sections/shop-the-look.js":
/*!******************************************************!*\
  !*** ./scripts/components/sections/shop-the-look.js ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var products = JSON.parse(node.dataset.productsObject);
  node.addEventListener('click', function () {
    // checks we're on mobile
    if (window.innerWidth < 768) {
      // updates the state with this section's products
      ctx.emit('shopThePopUp:update', function () {
        return {
          shopThePopUpProducts: products
        };
      });
      // sets the pop up's state to open
      ctx.emit('shopThePopUp:toggle', function () {
        return {
          shopThePopUpOpen: true
        };
      });
      ctx.emit('body:toggleScroll', function (_ref) {
        var enable = _ref.enable;
        return {
          enable: true
        };
      });
    }
  });
}));

/***/ }),

/***/ "./scripts/components/sections/shop-the-pop-up.js":
/*!********************************************************!*\
  !*** ./scripts/components/sections/shop-the-pop-up.js ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component(function (node, ctx) {
  var _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    close = _choozy.close,
    products = _choozy.products;

  // set the pop up's state to closed
  [].concat(close).forEach(function (eachClose) {
    eachClose.addEventListener('click', function () {
      ctx.emit('shopThePopUp:toggle', function () {
        return {
          shopThePopUpOpen: false
        };
      });
      ctx.emit('body:toggleScroll', function (_ref) {
        var enable = _ref.enable;
        return {
          enable: false
        };
      });
    });
  });

  // Updates the content in the pop up
  ctx.on('shopThePopUp:update', function (_ref2) {
    var shopThePopUpProducts = _ref2.shopThePopUpProducts;
    products.innerHTML = "\n      ".concat(shopThePopUpProducts.map(function (product) {
      return "\n        <div class='flex gap-[3.2rem] grow-0 border-b-black/10 border-b pb-[2rem] mb-[2rem] last-of-type:mb-0 last-of-type:pb-0 last-of-type:border-b-0'>\n          <div class=\"isolate relative flex-shrink-0\">\n            <img src=\"".concat(product.image, "\" class='w-[7.6rem] h-[11rem] object-contain'>\n            <div class=\"bg-grey-bg absolute inset-0 mix-blend-darken pointer-events-none\"></div>\n          </div>\n          <div class='flex flex-col text-body w-full'>\n            <div class='flex flex-col'>\n              <p class='text-navy'>").concat(product.title, "</p>\n              <p class='text-black/60'>").concat(product.price, "</p>\n            </div>\n            <a href='").concat(product.link, "' class='text-button inline-block text-navy border-black/20 border px-[4rem] py-[1.2rem] mt-[1.6rem] w-fit'>\n              <button class='text-button uppercase leading-tight'>\n                ").concat(product.view_more, "\n              </button>\n            </a>\n          </div>\n        </div>\n      ");
    }).join(' '), "\n    ");
  });

  // Closes the pop up on state
  ctx.on('shopThePopUp:toggle', function (_ref3) {
    var shopThePopUpOpen = _ref3.shopThePopUpOpen;
    node.classList[shopThePopUpOpen ? 'add' : 'remove']('open');
  });
}));

/***/ }),

/***/ "./scripts/components/sections/stores.js":
/*!***********************************************!*\
  !*** ./scripts/components/sections/stores.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _lib_choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../lib/choozy */ "./scripts/lib/choozy.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (window.component( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(node) {
    var _choozy, link;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _choozy = (0,_lib_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null), link = _choozy.link;
          [].concat(link).forEach(function (eachLink) {
            return eachLink.addEventListener('click', function () {
              document.querySelector("".concat(eachLink.dataset.linkId)).scrollIntoView({
                behavior: 'smooth'
              });
            });
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()));

/***/ }),

/***/ "./scripts/lib/cart.js":
/*!*****************************!*\
  !*** ./scripts/lib/cart.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addItemsById: () => (/* binding */ addItemsById),
/* harmony export */   addVariant: () => (/* binding */ addVariant),
/* harmony export */   clearCart: () => (/* binding */ clearCart),
/* harmony export */   fetchCart: () => (/* binding */ fetchCart),
/* harmony export */   fetchCartMarkup: () => (/* binding */ fetchCartMarkup),
/* harmony export */   removeAddon: () => (/* binding */ removeAddon),
/* harmony export */   updateAddon: () => (/* binding */ updateAddon)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function fetchCart() {
  return fetch("".concat(window.Phill.routes.cart, ".js"), {
    method: 'GET',
    credentials: 'include'
  }).then(function (res) {
    return res.json();
  });
}
function fetchCartMarkup() {
  return fetch("".concat(window.Phill.routes.cart, "?sections=cart-drawer"), {
    method: 'GET',
    credentials: 'include'
  }).then(function (res) {
    return res.json();
  });
}
function changeAddon(id, quantity) {
  window.app.emit('cart:updating');
  return fetch("".concat(window.Phill.routes.cartChange, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id: id,
      quantity: quantity,
      sections: 'cart-drawer'
    })
  }).then(function (res) {
    return res.json();
  }).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(cart) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            window.app.emit(['cart:updated', 'cart:render'], {
              cart: cart
            });
            return _context.abrupt("return", cart);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
}
function clearCart() {
  window.app.emit('cart:updating');
  return fetch("".concat(window.Phill.routes.cartClear, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      sections: 'cart-drawer'
    })
  }).then(function (r) {
    return r.json();
  }).then(function (cart) {
    window.app.emit(['cart:updated', 'cart:render'], {
      cart: cart
    });
    return cart;
  });
}
function addItemsById() {
  var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  window.app.emit('cart:updating');
  console.log('wow');
  return fetch("".concat(window.Phill.routes.cartAdd, ".js"), {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      items: items
    })
  }).then(function (r) {
    return r.json();
  }).then( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(item) {
      var _yield$Promise$all, _yield$Promise$all2, cart, cartMarkup;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!item.status) {
              _context2.next = 3;
              break;
            }
            window.app.emit(['cart:updated', 'cart:error'], null, item);
            return _context2.abrupt("return", {
              item: item,
              cart: window.app.getState().cart,
              error: item === null || item === void 0 ? void 0 : item.description
            });
          case 3:
            _context2.next = 5;
            return Promise.all([fetchCart(), fetchCartMarkup()]);
          case 5:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            cart = _yield$Promise$all2[0];
            cartMarkup = _yield$Promise$all2[1];
            cart.sections = cartMarkup;
            window.app.emit(['cart:updated', 'cart:render'], {
              cart: cart
            });
            return _context2.abrupt("return", {
              item: item,
              cart: cart
            });
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }());
}
function addVariant(variant, quantity) {
  var properties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return addItemsById([{
    id: variant.id,
    quantity: quantity,
    properties: properties
  }]);
}
function updateAddon(key, quantity) {
  return changeAddon(key, quantity);
}
function removeAddon(key) {
  return updateAddon(key, 0);
}

/***/ }),

/***/ "./scripts/lib/choozy.js":
/*!*******************************!*\
  !*** ./scripts/lib/choozy.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* export default binding */ __WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* eslint-disable */
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__() {
  var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'js-';
  var elements = _toConsumableArray(container.querySelectorAll(!prefix ? '*' : "[class*=\"".concat(prefix, "\"]")));
  var property = !prefix ? 'dataset' : 'classList';
  return elements.reduce(function (res, el) {
    [].slice.call(!prefix ? Object.entries(el[property]) : el[property]).forEach(function (property) {
      var key;
      if (prefix && property.slice(0, prefix.length) === prefix) key = property.slice(prefix.length, property.length);else if (!prefix) {
        var _property = _slicedToArray(property, 1);
        key = _property[0];
      }
      if (key) {
        res[key] = res.hasOwnProperty(key) ? res[key].constructor === Array ? res[key].concat(el) : [res[key], el] : el;
      }
    });
    return res;
  }, {});
}

/***/ }),

/***/ "./scripts/lib/currency.js":
/*!*********************************!*\
  !*** ./scripts/lib/currency.js ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   formatMoney: () => (/* binding */ formatMoney)
/* harmony export */ });
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

/**
 * Format money values based on your shop currency settings
 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
 * or 3.00 dollars
 * @param  {String} format - shop money_format setting
 * @return {String} value - formatted value
 */

/* eslint-disable */

function formatMoney(cents) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.Phill.money_format;
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (typeof precision == 'undefined') {
      precision = 2;
    }
    thousands = window.Phill.money_separator;
    decimal = thousands == ',' ? '.' : ',';
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    var parts = number.split('.');
    var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }
  switch (format.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0);
      break;
  }
  return format.replace(placeholderRegex, value);
}

/***/ }),

/***/ "./scripts/lib/get-style-var-value.js":
/*!********************************************!*\
  !*** ./scripts/lib/get-style-var-value.js ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var getVarValue = function getVarValue(element, value) {
  return parseInt(getComputedStyle(element).getPropertyValue(value));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (getVarValue);

/***/ }),

/***/ "./scripts/lib/is-different-variant.js":
/*!*********************************************!*\
  !*** ./scripts/lib/is-different-variant.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* eslint-disable no-prototype-builtins */
// We need this check if the same item is on PDP, PLP and Wishlist: so their local state won't be messed up
// TODO: add search check (if the same item is on PDP and search results)
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (_ref) {
  var productId = _ref.productId,
    data = _ref.data,
    isWishlistItem = _ref.isWishlistItem;
  return productId !== data.productId || isWishlistItem && !data.hasOwnProperty('wishlistItem') || !isWishlistItem && data.hasOwnProperty('wishlistItem');
});

/***/ }),

/***/ "./scripts/lib/listeners.js":
/*!**********************************!*\
  !*** ./scripts/lib/listeners.js ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var escKey = function escKey(_ref, _ref2) {
  var keyCode = _ref.keyCode;
  var type = _ref2.type,
    _boolean = _ref2["boolean"];
  if (keyCode === 27 && type && _boolean) window.app.emit(type, _defineProperty({}, _boolean, false));
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (escKey);

/***/ }),

/***/ "./scripts/lib/set-url-params.js":
/*!***************************************!*\
  !*** ./scripts/lib/set-url-params.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (parameters) {
  var url = new URL(window.location.href);
  var params = new URLSearchParams(url.search.slice(1));
  parameters.forEach(function (_ref) {
    var name = _ref.name,
      value = _ref.value;
    if (value !== '') params.set(name, encodeURIComponent(value));else params["delete"](name);
  });
  window.history.replaceState({}, '', "".concat(window.location.pathname, "?").concat(params.toString()));
});

/***/ }),

/***/ "./scripts/lib/string.js":
/*!*******************************!*\
  !*** ./scripts/lib/string.js ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   getCamelCase: () => (/* binding */ getCamelCase),
/* harmony export */   getString: () => (/* binding */ getString),
/* harmony export */   toCamelCase: () => (/* binding */ toCamelCase)
/* harmony export */ });
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var toCamelCase = function camalize(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
    return chr.toUpperCase();
  });
};
var getCamelCase = function getCamelCase(obj) {
  return Object.entries(obj).reduce(function (o, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    var object = o;
    object[toCamelCase(key)] = value;
    return object;
  }, {});
};
var getString = function getString(string) {
  var _window;
  /**
   * Get string from window.Phill.theme.strings
   * @param {String} string seperate keys, by . just like in liquid
   */

  return string.split('.').reduce(function (obj, str) {
    return obj === null || obj === void 0 ? void 0 : obj[str];
  }, (_window = window) === null || _window === void 0 || (_window = _window.Phill) === null || _window === void 0 || (_window = _window.theme) === null || _window === void 0 ? void 0 : _window.strings) || "Missing translation for ".concat(string, " in window.Phill");
};

/***/ }),

/***/ "./scripts/lib/subscribe-to-notifications.js":
/*!***************************************************!*\
  !*** ./scripts/lib/subscribe-to-notifications.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var subscribeToNotifications = function subscribeToNotifications(email, variant) {
  return fetch('https://a.klaviyo.com/onsite/components/back-in-stock/subscribe', {
    method: 'POST',
    mode: 'no-cors',
    body: new URLSearchParams({
      a: 'WdAbii',
      email: email,
      platform: 'shopify',
      variant: variant
    })
  }).then(function (res) {
    if (res.type === 'opaque') {
      return {
        success: true
      };
    }
    throw new Error('Something went wrong');
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (subscribeToNotifications);

/***/ }),

/***/ "./scripts/lib/update-details.js":
/*!***************************************!*\
  !*** ./scripts/lib/update-details.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choozy */ "./scripts/lib/choozy.js");

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variant, node) {
  var _choozy = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    infoColor = _choozy.infoColor,
    infoImage = _choozy.infoImage,
    sizeLabelContainer = _choozy.sizeLabelContainer;
  var infoImageList = infoImage ? [].concat(infoImage) : [];
  infoImageList.forEach(function (img) {
    img.classList[img.dataset.color === variant.option1 ? 'add' : 'remove']('is-active');
  });
  if (infoColor) {
    infoColor.innerHTML = variant.option1;
  }
  var sizeLabelContainerList = sizeLabelContainer ? [].concat(sizeLabelContainer) : [];
  sizeLabelContainerList.forEach(function (labelContainer) {
    labelContainer.classList[variant.available ? 'add' : 'remove']('is-active');
  });
});

/***/ }),

/***/ "./scripts/lib/update-discount.js":
/*!****************************************!*\
  !*** ./scripts/lib/update-discount.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choozy */ "./scripts/lib/choozy.js");


// TODO: Redo this for multiple discounts
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variant, node) {
  var _choozy = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    discountLabel = _choozy.discountLabel;
  if (!discountLabel) return;
  if (variant.compare_at_price) {
    var discountLabelElem = discountLabel instanceof Array ? discountLabel[0] : discountLabel;
    var _choozy2 = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(discountLabelElem, null),
      discount = _choozy2.discount;
    discountLabelElem.classList.add('is-active');
    discount.innerText = Math.trunc((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
  } else if (!(discountLabel instanceof Array)) {
    discountLabel.classList.remove('is-active');
  }
});

/***/ }),

/***/ "./scripts/lib/update-prices.js":
/*!**************************************!*\
  !*** ./scripts/lib/update-prices.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _currency__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./currency */ "./scripts/lib/currency.js");


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variant, node) {
  var _choozy = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    currentPrice = _choozy.price,
    currentCompareAtPrice = _choozy.compareAtPrice;
  var newPrice = variant.price,
    newCompareAtPrice = variant.compare_at_price;
  var priceList = currentPrice ? [].concat(currentPrice) : [];
  var compareAtPriceList = currentCompareAtPrice ? [].concat(currentCompareAtPrice) : [];
  priceList.forEach(function (priceElem, idx) {
    // eslint-disable-next-line no-param-reassign
    priceElem.innerHTML = (0,_currency__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(newPrice);
    compareAtPriceList[idx].innerHTML = newCompareAtPrice > newPrice ? (0,_currency__WEBPACK_IMPORTED_MODULE_1__.formatMoney)(newCompareAtPrice) : '';
    priceElem.classList[!compareAtPriceList[idx].textContent ? 'remove' : 'add']('is-active');
  });
});

/***/ }),

/***/ "./scripts/lib/update-sizes.js":
/*!*************************************!*\
  !*** ./scripts/lib/update-sizes.js ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choozy */ "./scripts/lib/choozy.js");
/* eslint-disable no-param-reassign */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variant, node) {
  var _choozy = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    sizeInput = _choozy.sizeInput,
    sizeContainer = _choozy.sizeContainer;
  var selectedColor = variant.option1,
    selectedSize = variant.option2;
  var sizeInputList = sizeInput ? [].concat(sizeInput) : [];
  var sizeContainerList = sizeContainer ? [].concat(sizeContainer) : [];

  // DO THIS ONLY ON COLOR CHANGE
  sizeContainerList.forEach(function (container) {
    container.classList[selectedColor === container.dataset.value ? 'add' : 'remove']('is-active');
  });
  var selectedInputList = sizeInputList.filter(function (input) {
    return input.value === selectedSize;
  });
  selectedInputList.forEach(function (input) {
    input.checked = true;
  });

  // DO WE NEED THIS????
  // const { currentColor } = choozy(e.target, null);
  // if (currentColor) {
  //   currentColor.innerHTML = selectedVariant.option1;
  // }
});

/***/ }),

/***/ "./scripts/lib/update-submit-text.js":
/*!*******************************************!*\
  !*** ./scripts/lib/update-submit-text.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _choozy__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choozy */ "./scripts/lib/choozy.js");
/* harmony import */ var _string__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./string */ "./scripts/lib/string.js");
/* eslint-disable no-param-reassign */


/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variant, node) {
  var _choozy = (0,_choozy__WEBPACK_IMPORTED_MODULE_0__["default"])(node, null),
    submitText = _choozy.submitText;
  var submitTextList = submitText ? [].concat(submitText) : [];
  submitTextList.forEach(function (submitTextElem) {
    submitTextElem.innerText = variant.available ? (0,_string__WEBPACK_IMPORTED_MODULE_1__.getString)('product.add_to_cart') : (0,_string__WEBPACK_IMPORTED_MODULE_1__.getString)('product.notify_me');
  });
});

/***/ }),

/***/ "./scripts/lib/updateWishlist.js":
/*!***************************************!*\
  !*** ./scripts/lib/updateWishlist.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _wishlist_util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./wishlist.util */ "./scripts/lib/wishlist.util.js");
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (variantGroupId, btn) {
  var inWishlist = (0,_wishlist_util__WEBPACK_IMPORTED_MODULE_0__.isVariantInWishlist)(variantGroupId);
  if (!btn) return;
  btn.classList[inWishlist ? 'add' : 'remove']('in-wishlist');
  btn.dataset.variantGroupId = variantGroupId;
});

/***/ }),

/***/ "./scripts/lib/waitToLoad.js":
/*!***********************************!*\
  !*** ./scripts/lib/waitToLoad.js ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var waitToLoad = function waitToLoad(scriptName) {
  return new Promise(function (res) {
    var _window;
    if ((_window = window) !== null && _window !== void 0 && (_window = _window.hasLoaded) !== null && _window !== void 0 && (_window = _window.scripts) !== null && _window !== void 0 && _window[scriptName]) res();else window.app.on("".concat(scriptName, ":loaded"), res);
  });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (waitToLoad);

/***/ }),

/***/ "./scripts/lib/wishlist.util.js":
/*!**************************************!*\
  !*** ./scripts/lib/wishlist.util.js ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   WISHLIST_KEY: () => (/* binding */ WISHLIST_KEY),
/* harmony export */   combineWishlists: () => (/* binding */ combineWishlists),
/* harmony export */   createWishlist: () => (/* binding */ createWishlist),
/* harmony export */   fetchWishlistItems: () => (/* binding */ fetchWishlistItems),
/* harmony export */   getWishlist: () => (/* binding */ getWishlist),
/* harmony export */   isVariantInWishlist: () => (/* binding */ isVariantInWishlist),
/* harmony export */   isWishlistEmpty: () => (/* binding */ isWishlistEmpty),
/* harmony export */   updateRemoteWishlist: () => (/* binding */ updateRemoteWishlist)
/* harmony export */ });
/* harmony import */ var _with_async_handler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./with-async-handler */ "./scripts/lib/with-async-handler.js");
/* provided dependency */ var process = __webpack_require__(/*! process/browser.js */ "./node_modules/process/browser.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/* eslint-disable no-unused-expressions */

var WISHLIST_KEY = 'askphill_wishlist';
var combineWishlists = function combineWishlists(wishlist1, wishlist2) {
  // get all unique variantIds (object keys) to iterate with
  var allVariantGroupIds = Object.keys(_objectSpread(_objectSpread({}, wishlist1.items), wishlist2.items));
  var latestUpdatedAt = wishlist1.lastUpdated > wishlist2.lastUpdated ? wishlist1.lastUpdated : wishlist2.lastUpdated;
  var combinedWishlist = {
    lastUpdated: latestUpdatedAt,
    items: {}
  };
  allVariantGroupIds.forEach(function (groupId) {
    // If the item exists on both wishlists
    if (wishlist1.items[groupId] && wishlist2.items[groupId]) {
      // if their timestamps are the same, return any
      if (wishlist1.items[groupId].updatedAt === wishlist2.items[groupId].updatedAt) {
        combinedWishlist.items[groupId] = _objectSpread({}, wishlist1.items[groupId]);
      } else {
        // else, find the one with the latest timestamp, use that wishlist's data
        var wishlistWithLatestData = wishlist1.items[groupId].updatedAt > wishlist2.items[groupId].updatedAt ? wishlist1 : wishlist2;
        combinedWishlist.items[groupId] = _objectSpread({}, wishlistWithLatestData.items[groupId]);
      }
    } else {
      // else it only exists in 1 wishlist, return that wishlist's data
      var wishlistWithExistingData = wishlist1.items[groupId] ? wishlist1 : wishlist2;
      combinedWishlist.items[groupId] = _objectSpread({}, wishlistWithExistingData.items[groupId]);
    }
  });
  return combinedWishlist;
};
var updateRemoteWishlist = function updateRemoteWishlist(data) {
  return fetch("".concat(process.env.API_URL, "/wishlist"), {
    method: 'POST',
    body: JSON.stringify(data)
  });
};
var isWishlistEmpty = function isWishlistEmpty(wishlist) {
  return !Object.keys(wishlist).length;
};
var createWishlist = function createWishlist(data) {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(data || {
    lastUpdated: Date.now(),
    items: {}
  }));
};
var getWishlist = function getWishlist() {
  return localStorage.getItem(WISHLIST_KEY);
};
var isVariantInWishlist = function isVariantInWishlist(variantGroupId) {
  var wishlist = getWishlist();
  if (!wishlist) return null;
  var wishlistData = JSON.parse(wishlist).items;
  var foundVariantKey = Object.keys(wishlistData).find(function (key) {
    return key === variantGroupId;
  });
  return foundVariantKey && wishlistData[foundVariantKey].inWishlist;
};
var fetchWishlistItems = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(ids) {
    var wishlist, wishlistData, variantIds;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          wishlist = getWishlist();
          if (wishlist) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return", null);
        case 3:
          wishlistData = JSON.parse(wishlist).items;
          variantIds = ids.length ? ids : Object.values(wishlistData).filter(function (_ref2) {
            var inWishlist = _ref2.inWishlist;
            return inWishlist;
          }).map(function (_ref3) {
            var variantId = _ref3.variantId;
            return variantId;
          });
          return _context.abrupt("return", (0,_with_async_handler__WEBPACK_IMPORTED_MODULE_0__["default"])(fetch("https://dstrezzed-serverless.vercel.app/api/fetch-product-variants?variantIds=".concat(variantIds.join(',')))));
        case 6:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function fetchWishlistItems(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ "./scripts/lib/with-async-handler.js":
/*!*******************************************!*\
  !*** ./scripts/lib/with-async-handler.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (function (promise) {
  return promise.then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
      var responseData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return res.json();
          case 2:
            responseData = _context.sent;
            if (res.ok) {
              _context.next = 5;
              break;
            }
            throw new Error(responseData);
          case 5:
            return _context.abrupt("return", responseData);
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
});

/***/ }),

/***/ "./scripts/util/photoswipe.js":
/*!************************************!*\
  !*** ./scripts/util/photoswipe.js ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PhotoSwipeLightbox)
/* harmony export */ });
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/*!
  * PhotoSwipe Lightbox 5.4.4 - https://photoswipe.com
  * (c) 2024 Dmytro Semenov
  */
/** @typedef {import('../photoswipe.js').Point} Point */

/**
 * @template {keyof HTMLElementTagNameMap} T
 * @param {string} className
 * @param {T} tagName
 * @param {Node} [appendToEl]
 * @returns {HTMLElementTagNameMap[T]}
 */
function createElement(className, tagName, appendToEl) {
  var el = document.createElement(tagName);
  if (className) {
    el.className = className;
  }
  if (appendToEl) {
    appendToEl.appendChild(el);
  }
  return el;
}
/**
 * Get transform string
 *
 * @param {number} x
 * @param {number} [y]
 * @param {number} [scale]
 * @returns {string}
 */

function toTransformString(x, y, scale) {
  var propValue = "translate3d(".concat(x, "px,").concat(y || 0, "px,0)");
  if (scale !== undefined) {
    propValue += " scale3d(".concat(scale, ",").concat(scale, ",1)");
  }
  return propValue;
}
/**
 * Apply width and height CSS properties to element
 *
 * @param {HTMLElement} el
 * @param {string | number} w
 * @param {string | number} h
 */

function setWidthHeight(el, w, h) {
  el.style.width = typeof w === 'number' ? "".concat(w, "px") : w;
  el.style.height = typeof h === 'number' ? "".concat(h, "px") : h;
}
/** @typedef {LOAD_STATE[keyof LOAD_STATE]} LoadState */

/** @type {{ IDLE: 'idle'; LOADING: 'loading'; LOADED: 'loaded'; ERROR: 'error' }} */

var LOAD_STATE = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};
/**
 * Check if click or keydown event was dispatched
 * with a special key or via mouse wheel.
 *
 * @param {MouseEvent | KeyboardEvent} e
 * @returns {boolean}
 */

function specialKeyUsed(e) {
  return 'button' in e && e.button === 1 || e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;
}
/**
 * Parse `gallery` or `children` options.
 *
 * @param {import('../photoswipe.js').ElementProvider} [option]
 * @param {string} [legacySelector]
 * @param {HTMLElement | Document} [parent]
 * @returns HTMLElement[]
 */

function getElementsFromOption(option, legacySelector) {
  var parent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : document;
  /** @type {HTMLElement[]} */
  var elements = [];
  if (option instanceof Element) {
    elements = [option];
  } else if (option instanceof NodeList || Array.isArray(option)) {
    elements = Array.from(option);
  } else {
    var selector = typeof option === 'string' ? option : legacySelector;
    if (selector) {
      elements = Array.from(parent.querySelectorAll(selector));
    }
  }
  return elements;
}
/**
 * Check if variable is PhotoSwipe class
 *
 * @param {any} fn
 * @returns {boolean}
 */

function isPswpClass(fn) {
  return typeof fn === 'function' && fn.prototype && fn.prototype.goTo;
}
/**
 * Check if browser is Safari
 *
 * @returns {boolean}
 */

function isSafari() {
  return !!(navigator.vendor && navigator.vendor.match(/apple/i));
}

/** @typedef {import('../lightbox/lightbox.js').default} PhotoSwipeLightbox */

/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../photoswipe.js').DataSource} DataSource */

/** @typedef {import('../ui/ui-element.js').UIElementData} UIElementData */

/** @typedef {import('../slide/content.js').default} ContentDefault */

/** @typedef {import('../slide/slide.js').default} Slide */

/** @typedef {import('../slide/slide.js').SlideData} SlideData */

/** @typedef {import('../slide/zoom-level.js').default} ZoomLevel */

/** @typedef {import('../slide/get-thumb-bounds.js').Bounds} Bounds */

/**
 * Allow adding an arbitrary props to the Content
 * https://photoswipe.com/custom-content/#using-webp-image-format
 * @typedef {ContentDefault & Record<string, any>} Content
 */

/** @typedef {{ x?: number; y?: number }} Point */

/**
 * @typedef {Object} PhotoSwipeEventsMap https://photoswipe.com/events/
 *
 *
 * https://photoswipe.com/adding-ui-elements/
 *
 * @prop {undefined} uiRegister
 * @prop {{ data: UIElementData }} uiElementCreate
 *
 *
 * https://photoswipe.com/events/#initialization-events
 *
 * @prop {undefined} beforeOpen
 * @prop {undefined} firstUpdate
 * @prop {undefined} initialLayout
 * @prop {undefined} change
 * @prop {undefined} afterInit
 * @prop {undefined} bindEvents
 *
 *
 * https://photoswipe.com/events/#opening-or-closing-transition-events
 *
 * @prop {undefined} openingAnimationStart
 * @prop {undefined} openingAnimationEnd
 * @prop {undefined} closingAnimationStart
 * @prop {undefined} closingAnimationEnd
 *
 *
 * https://photoswipe.com/events/#closing-events
 *
 * @prop {undefined} close
 * @prop {undefined} destroy
 *
 *
 * https://photoswipe.com/events/#pointer-and-gesture-events
 *
 * @prop {{ originalEvent: PointerEvent }} pointerDown
 * @prop {{ originalEvent: PointerEvent }} pointerMove
 * @prop {{ originalEvent: PointerEvent }} pointerUp
 * @prop {{ bgOpacity: number }} pinchClose can be default prevented
 * @prop {{ panY: number }} verticalDrag can be default prevented
 *
 *
 * https://photoswipe.com/events/#slide-content-events
 *
 * @prop {{ content: Content }} contentInit
 * @prop {{ content: Content; isLazy: boolean }} contentLoad can be default prevented
 * @prop {{ content: Content; isLazy: boolean }} contentLoadImage can be default prevented
 * @prop {{ content: Content; slide: Slide; isError?: boolean }} loadComplete
 * @prop {{ content: Content; slide: Slide }} loadError
 * @prop {{ content: Content; width: number; height: number }} contentResize can be default prevented
 * @prop {{ content: Content; width: number; height: number; slide: Slide }} imageSizeChange
 * @prop {{ content: Content }} contentLazyLoad can be default prevented
 * @prop {{ content: Content }} contentAppend can be default prevented
 * @prop {{ content: Content }} contentActivate can be default prevented
 * @prop {{ content: Content }} contentDeactivate can be default prevented
 * @prop {{ content: Content }} contentRemove can be default prevented
 * @prop {{ content: Content }} contentDestroy can be default prevented
 *
 *
 * undocumented
 *
 * @prop {{ point: Point; originalEvent: PointerEvent }} imageClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} bgClickAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} tapAction can be default prevented
 * @prop {{ point: Point; originalEvent: PointerEvent }} doubleTapAction can be default prevented
 *
 * @prop {{ originalEvent: KeyboardEvent }} keydown can be default prevented
 * @prop {{ x: number; dragging: boolean }} moveMainScroll
 * @prop {{ slide: Slide }} firstZoomPan
 * @prop {{ slide: Slide | undefined, data: SlideData, index: number }} gettingData
 * @prop {undefined} beforeResize
 * @prop {undefined} resize
 * @prop {undefined} viewportSize
 * @prop {undefined} updateScrollOffset
 * @prop {{ slide: Slide }} slideInit
 * @prop {{ slide: Slide }} afterSetContent
 * @prop {{ slide: Slide }} slideLoad
 * @prop {{ slide: Slide }} appendHeavy can be default prevented
 * @prop {{ slide: Slide }} appendHeavyContent
 * @prop {{ slide: Slide }} slideActivate
 * @prop {{ slide: Slide }} slideDeactivate
 * @prop {{ slide: Slide }} slideDestroy
 * @prop {{ destZoomLevel: number, centerPoint: Point | undefined, transitionDuration: number | false | undefined }} beforeZoomTo
 * @prop {{ slide: Slide }} zoomPanUpdate
 * @prop {{ slide: Slide }} initialZoomPan
 * @prop {{ slide: Slide }} calcSlideSize
 * @prop {undefined} resolutionChanged
 * @prop {{ originalEvent: WheelEvent }} wheel can be default prevented
 * @prop {{ content: Content }} contentAppendImage can be default prevented
 * @prop {{ index: number; itemData: SlideData }} lazyLoadSlide can be default prevented
 * @prop {undefined} lazyLoad
 * @prop {{ slide: Slide }} calcBounds
 * @prop {{ zoomLevels: ZoomLevel, slideData: SlideData }} zoomLevelsUpdate
 *
 *
 * legacy
 *
 * @prop {undefined} init
 * @prop {undefined} initialZoomIn
 * @prop {undefined} initialZoomOut
 * @prop {undefined} initialZoomInEnd
 * @prop {undefined} initialZoomOutEnd
 * @prop {{ dataSource: DataSource | undefined, numItems: number }} numItems
 * @prop {{ itemData: SlideData; index: number }} itemData
 * @prop {{ index: number, itemData: SlideData, instance: PhotoSwipe }} thumbBounds
 */

/**
 * @typedef {Object} PhotoSwipeFiltersMap https://photoswipe.com/filters/
 *
 * @prop {(numItems: number, dataSource: DataSource | undefined) => number} numItems
 * Modify the total amount of slides. Example on Data sources page.
 * https://photoswipe.com/filters/#numitems
 *
 * @prop {(itemData: SlideData, index: number) => SlideData} itemData
 * Modify slide item data. Example on Data sources page.
 * https://photoswipe.com/filters/#itemdata
 *
 * @prop {(itemData: SlideData, element: HTMLElement, linkEl: HTMLAnchorElement) => SlideData} domItemData
 * Modify item data when it's parsed from DOM element. Example on Data sources page.
 * https://photoswipe.com/filters/#domitemdata
 *
 * @prop {(clickedIndex: number, e: MouseEvent, instance: PhotoSwipeLightbox) => number} clickedIndex
 * Modify clicked gallery item index.
 * https://photoswipe.com/filters/#clickedindex
 *
 * @prop {(placeholderSrc: string | false, content: Content) => string | false} placeholderSrc
 * Modify placeholder image source.
 * https://photoswipe.com/filters/#placeholdersrc
 *
 * @prop {(isContentLoading: boolean, content: Content) => boolean} isContentLoading
 * Modify if the content is currently loading.
 * https://photoswipe.com/filters/#iscontentloading
 *
 * @prop {(isContentZoomable: boolean, content: Content) => boolean} isContentZoomable
 * Modify if the content can be zoomed.
 * https://photoswipe.com/filters/#iscontentzoomable
 *
 * @prop {(useContentPlaceholder: boolean, content: Content) => boolean} useContentPlaceholder
 * Modify if the placeholder should be used for the content.
 * https://photoswipe.com/filters/#usecontentplaceholder
 *
 * @prop {(isKeepingPlaceholder: boolean, content: Content) => boolean} isKeepingPlaceholder
 * Modify if the placeholder should be kept after the content is loaded.
 * https://photoswipe.com/filters/#iskeepingplaceholder
 *
 *
 * @prop {(contentErrorElement: HTMLElement, content: Content) => HTMLElement} contentErrorElement
 * Modify an element when the content has error state (for example, if image cannot be loaded).
 * https://photoswipe.com/filters/#contenterrorelement
 *
 * @prop {(element: HTMLElement, data: UIElementData) => HTMLElement} uiElement
 * Modify a UI element that's being created.
 * https://photoswipe.com/filters/#uielement
 *
 * @prop {(thumbnail: HTMLElement | null | undefined, itemData: SlideData, index: number) => HTMLElement} thumbEl
 * Modify the thumbnail element from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbel
 *
 * @prop {(thumbBounds: Bounds | undefined, itemData: SlideData, index: number) => Bounds} thumbBounds
 * Modify the thumbnail bounds from which opening zoom animation starts or ends.
 * https://photoswipe.com/filters/#thumbbounds
 *
 * @prop {(srcsetSizesWidth: number, content: Content) => number} srcsetSizesWidth
 *
 * @prop {(preventPointerEvent: boolean, event: PointerEvent, pointerType: string) => boolean} preventPointerEvent
 *
 */

/**
 * @template {keyof PhotoSwipeFiltersMap} T
 * @typedef {{ fn: PhotoSwipeFiltersMap[T], priority: number }} Filter
 */

/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {PhotoSwipeEventsMap[T] extends undefined ? PhotoSwipeEvent<T> : PhotoSwipeEvent<T> & PhotoSwipeEventsMap[T]} AugmentedEvent
 */

/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {(event: AugmentedEvent<T>) => void} EventCallback
 */

/**
 * Base PhotoSwipe event object
 *
 * @template {keyof PhotoSwipeEventsMap} T
 */
var PhotoSwipeEvent = /*#__PURE__*/function () {
  /**
   * @param {T} type
   * @param {PhotoSwipeEventsMap[T]} [details]
   */
  function PhotoSwipeEvent(type, details) {
    _classCallCheck(this, PhotoSwipeEvent);
    this.type = type;
    this.defaultPrevented = false;
    if (details) {
      Object.assign(this, details);
    }
  }
  return _createClass(PhotoSwipeEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.defaultPrevented = true;
    }
  }]);
}();
/**
 * PhotoSwipe base class that can listen and dispatch for events.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox, extended by base.js
 */
var Eventable = /*#__PURE__*/function () {
  function Eventable() {
    _classCallCheck(this, Eventable);
    /**
     * @type {{ [T in keyof PhotoSwipeEventsMap]?: ((event: AugmentedEvent<T>) => void)[] }}
     */
    this._listeners = {};
    /**
     * @type {{ [T in keyof PhotoSwipeFiltersMap]?: Filter<T>[] }}
     */

    this._filters = {};
    /** @type {PhotoSwipe | undefined} */

    this.pswp = undefined;
    /** @type {PhotoSwipeOptions | undefined} */

    this.options = undefined;
  }
  /**
   * @template {keyof PhotoSwipeFiltersMap} T
   * @param {T} name
   * @param {PhotoSwipeFiltersMap[T]} fn
   * @param {number} priority
   */
  return _createClass(Eventable, [{
    key: "addFilter",
    value: function addFilter(name, fn) {
      var priority = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
      var _this$_filters$name, _this$_filters$name2, _this$pswp;
      if (!this._filters[name]) {
        this._filters[name] = [];
      }
      (_this$_filters$name = this._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.push({
        fn: fn,
        priority: priority
      });
      (_this$_filters$name2 = this._filters[name]) === null || _this$_filters$name2 === void 0 || _this$_filters$name2.sort(function (f1, f2) {
        return f1.priority - f2.priority;
      });
      (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.addFilter(name, fn, priority);
    }
    /**
     * @template {keyof PhotoSwipeFiltersMap} T
     * @param {T} name
     * @param {PhotoSwipeFiltersMap[T]} fn
     */
  }, {
    key: "removeFilter",
    value: function removeFilter(name, fn) {
      if (this._filters[name]) {
        // @ts-expect-error
        this._filters[name] = this._filters[name].filter(function (filter) {
          return filter.fn !== fn;
        });
      }
      if (this.pswp) {
        this.pswp.removeFilter(name, fn);
      }
    }
    /**
     * @template {keyof PhotoSwipeFiltersMap} T
     * @param {T} name
     * @param {Parameters<PhotoSwipeFiltersMap[T]>} args
     * @returns {Parameters<PhotoSwipeFiltersMap[T]>[0]}
     */
  }, {
    key: "applyFilters",
    value: function applyFilters(name) {
      var _this = this;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      var _this$_filters$name3;
      (_this$_filters$name3 = this._filters[name]) === null || _this$_filters$name3 === void 0 || _this$_filters$name3.forEach(function (filter) {
        // @ts-expect-error
        args[0] = filter.fn.apply(_this, args);
      });
      return args[0];
    }
    /**
     * @template {keyof PhotoSwipeEventsMap} T
     * @param {T} name
     * @param {EventCallback<T>} fn
     */
  }, {
    key: "on",
    value: function on(name, fn) {
      var _this$_listeners$name, _this$pswp2;
      if (!this._listeners[name]) {
        this._listeners[name] = [];
      }
      (_this$_listeners$name = this._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.push(fn); // When binding events to lightbox,
      // also bind events to PhotoSwipe Core,
      // if it's open.

      (_this$pswp2 = this.pswp) === null || _this$pswp2 === void 0 || _this$pswp2.on(name, fn);
    }
    /**
     * @template {keyof PhotoSwipeEventsMap} T
     * @param {T} name
     * @param {EventCallback<T>} fn
     */
  }, {
    key: "off",
    value: function off(name, fn) {
      var _this$pswp3;
      if (this._listeners[name]) {
        // @ts-expect-error
        this._listeners[name] = this._listeners[name].filter(function (listener) {
          return fn !== listener;
        });
      }
      (_this$pswp3 = this.pswp) === null || _this$pswp3 === void 0 || _this$pswp3.off(name, fn);
    }
    /**
     * @template {keyof PhotoSwipeEventsMap} T
     * @param {T} name
     * @param {PhotoSwipeEventsMap[T]} [details]
     * @returns {AugmentedEvent<T>}
     */
  }, {
    key: "dispatch",
    value: function dispatch(name, details) {
      var _this2 = this;
      var _this$_listeners$name2;
      if (this.pswp) {
        return this.pswp.dispatch(name, details);
      }
      var event = /** @type {AugmentedEvent<T>} */
      new PhotoSwipeEvent(name, details);
      (_this$_listeners$name2 = this._listeners[name]) === null || _this$_listeners$name2 === void 0 || _this$_listeners$name2.forEach(function (listener) {
        listener.call(_this2, event);
      });
      return event;
    }
  }]);
}();
var Placeholder = /*#__PURE__*/function () {
  /**
   * @param {string | false} imageSrc
   * @param {HTMLElement} container
   */
  function Placeholder(imageSrc, container) {
    _classCallCheck(this, Placeholder);
    // Create placeholder
    // (stretched thumbnail or simple div behind the main image)

    /** @type {HTMLImageElement | HTMLDivElement | null} */
    this.element = createElement('pswp__img pswp__img--placeholder', imageSrc ? 'img' : 'div', container);
    if (imageSrc) {
      var imgEl = /** @type {HTMLImageElement} */
      this.element;
      imgEl.decoding = 'async';
      imgEl.alt = '';
      imgEl.src = imageSrc;
      imgEl.setAttribute('role', 'presentation');
    }
    this.element.setAttribute('aria-hidden', 'true');
  }
  /**
   * @param {number} width
   * @param {number} height
   */
  return _createClass(Placeholder, [{
    key: "setDisplayedSize",
    value: function setDisplayedSize(width, height) {
      if (!this.element) {
        return;
      }
      if (this.element.tagName === 'IMG') {
        // Use transform scale() to modify img placeholder size
        // (instead of changing width/height directly).
        // This helps with performance, specifically in iOS15 Safari.
        setWidthHeight(this.element, 250, 'auto');
        this.element.style.transformOrigin = '0 0';
        this.element.style.transform = toTransformString(0, 0, width / 250);
      } else {
        setWidthHeight(this.element, width, height);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      var _this$element;
      if ((_this$element = this.element) !== null && _this$element !== void 0 && _this$element.parentNode) {
        this.element.remove();
      }
      this.element = null;
    }
  }]);
}();
/** @typedef {import('./slide.js').default} Slide */
/** @typedef {import('./slide.js').SlideData} SlideData */
/** @typedef {import('../core/base.js').default} PhotoSwipeBase */
/** @typedef {import('../util/util.js').LoadState} LoadState */
var Content = /*#__PURE__*/function () {
  /**
   * @param {SlideData} itemData Slide data
   * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
   * @param {number} index
   */
  function Content(itemData, instance, index) {
    _classCallCheck(this, Content);
    this.instance = instance;
    this.data = itemData;
    this.index = index;
    /** @type {HTMLImageElement | HTMLDivElement | undefined} */

    this.element = undefined;
    /** @type {Placeholder | undefined} */

    this.placeholder = undefined;
    /** @type {Slide | undefined} */

    this.slide = undefined;
    this.displayedImageWidth = 0;
    this.displayedImageHeight = 0;
    this.width = Number(this.data.w) || Number(this.data.width) || 0;
    this.height = Number(this.data.h) || Number(this.data.height) || 0;
    this.isAttached = false;
    this.hasSlide = false;
    this.isDecoding = false;
    /** @type {LoadState} */

    this.state = LOAD_STATE.IDLE;
    if (this.data.type) {
      this.type = this.data.type;
    } else if (this.data.src) {
      this.type = 'image';
    } else {
      this.type = 'html';
    }
    this.instance.dispatch('contentInit', {
      content: this
    });
  }
  return _createClass(Content, [{
    key: "removePlaceholder",
    value: function removePlaceholder() {
      var _this3 = this;
      if (this.placeholder && !this.keepPlaceholder()) {
        // With delay, as image might be loaded, but not rendered
        setTimeout(function () {
          if (_this3.placeholder) {
            _this3.placeholder.destroy();
            _this3.placeholder = undefined;
          }
        }, 1000);
      }
    }
    /**
     * Preload content
     *
     * @param {boolean} isLazy
     * @param {boolean} [reload]
     */
  }, {
    key: "load",
    value: function load(isLazy, reload) {
      if (this.slide && this.usePlaceholder()) {
        if (!this.placeholder) {
          var placeholderSrc = this.instance.applyFilters('placeholderSrc',
          // use  image-based placeholder only for the first slide,
          // as rendering (even small stretched thumbnail) is an expensive operation
          this.data.msrc && this.slide.isFirstSlide ? this.data.msrc : false, this);
          this.placeholder = new Placeholder(placeholderSrc, this.slide.container);
        } else {
          var placeholderEl = this.placeholder.element; // Add placeholder to DOM if it was already created

          if (placeholderEl && !placeholderEl.parentElement) {
            this.slide.container.prepend(placeholderEl);
          }
        }
      }
      if (this.element && !reload) {
        return;
      }
      if (this.instance.dispatch('contentLoad', {
        content: this,
        isLazy: isLazy
      }).defaultPrevented) {
        return;
      }
      if (this.isImageContent()) {
        this.element = createElement('pswp__img', 'img'); // Start loading only after width is defined, as sizes might depend on it.
        // Due to Safari feature, we must define sizes before srcset.

        if (this.displayedImageWidth) {
          this.loadImage(isLazy);
        }
      } else {
        this.element = createElement('pswp__content', 'div');
        this.element.innerHTML = this.data.html || '';
      }
      if (reload && this.slide) {
        this.slide.updateContentSize(true);
      }
    }
    /**
     * Preload image
     *
     * @param {boolean} isLazy
     */
  }, {
    key: "loadImage",
    value: function loadImage(isLazy) {
      var _this4 = this;
      var _this$data$src, _this$data$alt;
      if (!this.isImageContent() || !this.element || this.instance.dispatch('contentLoadImage', {
        content: this,
        isLazy: isLazy
      }).defaultPrevented) {
        return;
      }
      var imageElement = /** @type HTMLImageElement */
      this.element;
      this.updateSrcsetSizes();
      if (this.data.srcset) {
        imageElement.srcset = this.data.srcset;
      }
      imageElement.src = (_this$data$src = this.data.src) !== null && _this$data$src !== void 0 ? _this$data$src : '';
      imageElement.alt = (_this$data$alt = this.data.alt) !== null && _this$data$alt !== void 0 ? _this$data$alt : '';
      this.state = LOAD_STATE.LOADING;
      if (imageElement.complete) {
        this.onLoaded();
      } else {
        imageElement.onload = function () {
          _this4.onLoaded();
        };
        imageElement.onerror = function () {
          _this4.onError();
        };
      }
    }
    /**
     * Assign slide to content
     *
     * @param {Slide} slide
     */
  }, {
    key: "setSlide",
    value: function setSlide(slide) {
      this.slide = slide;
      this.hasSlide = true;
      this.instance = slide.pswp; // todo: do we need to unset slide?
    }
    /**
     * Content load success handler
     */
  }, {
    key: "onLoaded",
    value: function onLoaded() {
      this.state = LOAD_STATE.LOADED;
      if (this.slide && this.element) {
        this.instance.dispatch('loadComplete', {
          slide: this.slide,
          content: this
        }); // if content is reloaded

        if (this.slide.isActive && this.slide.heavyAppended && !this.element.parentNode) {
          this.append();
          this.slide.updateContentSize(true);
        }
        if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
          this.removePlaceholder();
        }
      }
    }
    /**
     * Content load error handler
     */
  }, {
    key: "onError",
    value: function onError() {
      this.state = LOAD_STATE.ERROR;
      if (this.slide) {
        this.displayError();
        this.instance.dispatch('loadComplete', {
          slide: this.slide,
          isError: true,
          content: this
        });
        this.instance.dispatch('loadError', {
          slide: this.slide,
          content: this
        });
      }
    }
    /**
     * @returns {Boolean} If the content is currently loading
     */
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.instance.applyFilters('isContentLoading', this.state === LOAD_STATE.LOADING, this);
    }
    /**
     * @returns {Boolean} If the content is in error state
     */
  }, {
    key: "isError",
    value: function isError() {
      return this.state === LOAD_STATE.ERROR;
    }
    /**
     * @returns {boolean} If the content is image
     */
  }, {
    key: "isImageContent",
    value: function isImageContent() {
      return this.type === 'image';
    }
    /**
     * Update content size
     *
     * @param {Number} width
     * @param {Number} height
     */
  }, {
    key: "setDisplayedSize",
    value: function setDisplayedSize(width, height) {
      if (!this.element) {
        return;
      }
      if (this.placeholder) {
        this.placeholder.setDisplayedSize(width, height);
      }
      if (this.instance.dispatch('contentResize', {
        content: this,
        width: width,
        height: height
      }).defaultPrevented) {
        return;
      }
      setWidthHeight(this.element, width, height);
      if (this.isImageContent() && !this.isError()) {
        var isInitialSizeUpdate = !this.displayedImageWidth && width;
        this.displayedImageWidth = width;
        this.displayedImageHeight = height;
        if (isInitialSizeUpdate) {
          this.loadImage(false);
        } else {
          this.updateSrcsetSizes();
        }
        if (this.slide) {
          this.instance.dispatch('imageSizeChange', {
            slide: this.slide,
            width: width,
            height: height,
            content: this
          });
        }
      }
    }
    /**
     * @returns {boolean} If the content can be zoomed
     */
  }, {
    key: "isZoomable",
    value: function isZoomable() {
      return this.instance.applyFilters('isContentZoomable', this.isImageContent() && this.state !== LOAD_STATE.ERROR, this);
    }
    /**
     * Update image srcset sizes attribute based on width and height
     */
  }, {
    key: "updateSrcsetSizes",
    value: function updateSrcsetSizes() {
      // Handle srcset sizes attribute.
      //
      // Never lower quality, if it was increased previously.
      // Chrome does this automatically, Firefox and Safari do not,
      // so we store largest used size in dataset.
      if (!this.isImageContent() || !this.element || !this.data.srcset) {
        return;
      }
      var image = /** @type HTMLImageElement */
      this.element;
      var sizesWidth = this.instance.applyFilters('srcsetSizesWidth', this.displayedImageWidth, this);
      if (!image.dataset.largestUsedSize || sizesWidth > parseInt(image.dataset.largestUsedSize, 10)) {
        image.sizes = sizesWidth + 'px';
        image.dataset.largestUsedSize = String(sizesWidth);
      }
    }
    /**
     * @returns {boolean} If content should use a placeholder (from msrc by default)
     */
  }, {
    key: "usePlaceholder",
    value: function usePlaceholder() {
      return this.instance.applyFilters('useContentPlaceholder', this.isImageContent(), this);
    }
    /**
     * Preload content with lazy-loading param
     */
  }, {
    key: "lazyLoad",
    value: function lazyLoad() {
      if (this.instance.dispatch('contentLazyLoad', {
        content: this
      }).defaultPrevented) {
        return;
      }
      this.load(true);
    }
    /**
     * @returns {boolean} If placeholder should be kept after content is loaded
     */
  }, {
    key: "keepPlaceholder",
    value: function keepPlaceholder() {
      return this.instance.applyFilters('isKeepingPlaceholder', this.isLoading(), this);
    }
    /**
     * Destroy the content
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.hasSlide = false;
      this.slide = undefined;
      if (this.instance.dispatch('contentDestroy', {
        content: this
      }).defaultPrevented) {
        return;
      }
      this.remove();
      if (this.placeholder) {
        this.placeholder.destroy();
        this.placeholder = undefined;
      }
      if (this.isImageContent() && this.element) {
        this.element.onload = null;
        this.element.onerror = null;
        this.element = undefined;
      }
    }
    /**
     * Display error message
     */
  }, {
    key: "displayError",
    value: function displayError() {
      if (this.slide) {
        var _this$instance$option, _this$instance$option2;
        var errorMsgEl = createElement('pswp__error-msg', 'div');
        errorMsgEl.innerText = (_this$instance$option = (_this$instance$option2 = this.instance.options) === null || _this$instance$option2 === void 0 ? void 0 : _this$instance$option2.errorMsg) !== null && _this$instance$option !== void 0 ? _this$instance$option : '';
        errorMsgEl = /** @type {HTMLDivElement} */
        this.instance.applyFilters('contentErrorElement', errorMsgEl, this);
        this.element = createElement('pswp__content pswp__error-msg-container', 'div');
        this.element.appendChild(errorMsgEl);
        this.slide.container.innerText = '';
        this.slide.container.appendChild(this.element);
        this.slide.updateContentSize(true);
        this.removePlaceholder();
      }
    }
    /**
     * Append the content
     */
  }, {
    key: "append",
    value: function append() {
      var _this5 = this;
      if (this.isAttached || !this.element) {
        return;
      }
      this.isAttached = true;
      if (this.state === LOAD_STATE.ERROR) {
        this.displayError();
        return;
      }
      if (this.instance.dispatch('contentAppend', {
        content: this
      }).defaultPrevented) {
        return;
      }
      var supportsDecode = 'decode' in this.element;
      if (this.isImageContent()) {
        // Use decode() on nearby slides
        //
        // Nearby slide images are in DOM and not hidden via display:none.
        // However, they are placed offscreen (to the left and right side).
        //
        // Some browsers do not composite the image until it's actually visible,
        // using decode() helps.
        //
        // You might ask "why dont you just decode() and then append all images",
        // that's because I want to show image before it's fully loaded,
        // as browser can render parts of image while it is loading.
        // We do not do this in Safari due to partial loading bug.
        if (supportsDecode && this.slide && (!this.slide.isActive || isSafari())) {
          this.isDecoding = true; // purposefully using finally instead of then,
          // as if srcset sizes changes dynamically - it may cause decode error

          /** @type {HTMLImageElement} */

          this.element.decode()["catch"](function () {})["finally"](function () {
            _this5.isDecoding = false;
            _this5.appendImage();
          });
        } else {
          this.appendImage();
        }
      } else if (this.slide && !this.element.parentNode) {
        this.slide.container.appendChild(this.element);
      }
    }
    /**
     * Activate the slide,
     * active slide is generally the current one,
     * meaning the user can see it.
     */
  }, {
    key: "activate",
    value: function activate() {
      if (this.instance.dispatch('contentActivate', {
        content: this
      }).defaultPrevented || !this.slide) {
        return;
      }
      if (this.isImageContent() && this.isDecoding && !isSafari()) {
        // add image to slide when it becomes active,
        // even if it's not finished decoding
        this.appendImage();
      } else if (this.isError()) {
        this.load(false, true); // try to reload
      }
      if (this.slide.holderElement) {
        this.slide.holderElement.setAttribute('aria-hidden', 'false');
      }
    }
    /**
     * Deactivate the content
     */
  }, {
    key: "deactivate",
    value: function deactivate() {
      this.instance.dispatch('contentDeactivate', {
        content: this
      });
      if (this.slide && this.slide.holderElement) {
        this.slide.holderElement.setAttribute('aria-hidden', 'true');
      }
    }
    /**
     * Remove the content from DOM
     */
  }, {
    key: "remove",
    value: function remove() {
      this.isAttached = false;
      if (this.instance.dispatch('contentRemove', {
        content: this
      }).defaultPrevented) {
        return;
      }
      if (this.element && this.element.parentNode) {
        this.element.remove();
      }
      if (this.placeholder && this.placeholder.element) {
        this.placeholder.element.remove();
      }
    }
    /**
     * Append the image content to slide container
     */
  }, {
    key: "appendImage",
    value: function appendImage() {
      if (!this.isAttached) {
        return;
      }
      if (this.instance.dispatch('contentAppendImage', {
        content: this
      }).defaultPrevented) {
        return;
      } // ensure that element exists and is not already appended

      if (this.slide && this.element && !this.element.parentNode) {
        this.slide.container.appendChild(this.element);
      }
      if (this.state === LOAD_STATE.LOADED || this.state === LOAD_STATE.ERROR) {
        this.removePlaceholder();
      }
    }
  }]);
}();
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
/** @typedef {import('../core/base.js').default} PhotoSwipeBase */
/** @typedef {import('../photoswipe.js').Point} Point */
/** @typedef {import('../slide/slide.js').SlideData} SlideData */
/**
 * @param {PhotoSwipeOptions} options
 * @param {PhotoSwipeBase} pswp
 * @returns {Point}
 */
function getViewportSize(options, pswp) {
  if (options.getViewportSizeFn) {
    var newViewportSize = options.getViewportSizeFn(options, pswp);
    if (newViewportSize) {
      return newViewportSize;
    }
  }
  return {
    x: document.documentElement.clientWidth,
    // TODO: height on mobile is very incosistent due to toolbar
    // find a way to improve this
    //
    // document.documentElement.clientHeight - doesn't seem to work well
    y: window.innerHeight
  };
}
/**
 * Parses padding option.
 * Supported formats:
 *
 * // Object
 * padding: {
 *  top: 0,
 *  bottom: 0,
 *  left: 0,
 *  right: 0
 * }
 *
 * // A function that returns the object
 * paddingFn: (viewportSize, itemData, index) => {
 *  return {
 *    top: 0,
 *    bottom: 0,
 *    left: 0,
 *    right: 0
 *  };
 * }
 *
 * // Legacy variant
 * paddingLeft: 0,
 * paddingRight: 0,
 * paddingTop: 0,
 * paddingBottom: 0,
 *
 * @param {'left' | 'top' | 'bottom' | 'right'} prop
 * @param {PhotoSwipeOptions} options PhotoSwipe options
 * @param {Point} viewportSize PhotoSwipe viewport size, for example: { x:800, y:600 }
 * @param {SlideData} itemData Data about the slide
 * @param {number} index Slide index
 * @returns {number}
 */

function parsePaddingOption(prop, options, viewportSize, itemData, index) {
  var paddingValue = 0;
  if (options.paddingFn) {
    paddingValue = options.paddingFn(viewportSize, itemData, index)[prop];
  } else if (options.padding) {
    paddingValue = options.padding[prop];
  } else {
    var legacyPropName = 'padding' + prop[0].toUpperCase() + prop.slice(1); // @ts-expect-error

    if (options[legacyPropName]) {
      // @ts-expect-error
      paddingValue = options[legacyPropName];
    }
  }
  return Number(paddingValue) || 0;
}
/**
 * @param {PhotoSwipeOptions} options
 * @param {Point} viewportSize
 * @param {SlideData} itemData
 * @param {number} index
 * @returns {Point}
 */

function getPanAreaSize(options, viewportSize, itemData, index) {
  return {
    x: viewportSize.x - parsePaddingOption('left', options, viewportSize, itemData, index) - parsePaddingOption('right', options, viewportSize, itemData, index),
    y: viewportSize.y - parsePaddingOption('top', options, viewportSize, itemData, index) - parsePaddingOption('bottom', options, viewportSize, itemData, index)
  };
}
var MAX_IMAGE_WIDTH = 4000;
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */

/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */

/** @typedef {import('../photoswipe.js').Point} Point */

/** @typedef {import('../slide/slide.js').SlideData} SlideData */

/** @typedef {'fit' | 'fill' | number | ((zoomLevelObject: ZoomLevel) => number)} ZoomLevelOption */

/**
 * Calculates zoom levels for specific slide.
 * Depends on viewport size and image size.
 */
var ZoomLevel = /*#__PURE__*/function () {
  /**
   * @param {PhotoSwipeOptions} options PhotoSwipe options
   * @param {SlideData} itemData Slide data
   * @param {number} index Slide index
   * @param {PhotoSwipe} [pswp] PhotoSwipe instance, can be undefined if not initialized yet
   */
  function ZoomLevel(options, itemData, index, pswp) {
    _classCallCheck(this, ZoomLevel);
    this.pswp = pswp;
    this.options = options;
    this.itemData = itemData;
    this.index = index;
    /** @type { Point | null } */

    this.panAreaSize = null;
    /** @type { Point | null } */

    this.elementSize = null;
    this.fit = 1;
    this.fill = 1;
    this.vFill = 1;
    this.initial = 1;
    this.secondary = 1;
    this.max = 1;
    this.min = 1;
  }
  /**
   * Calculate initial, secondary and maximum zoom level for the specified slide.
   *
   * It should be called when either image or viewport size changes.
   *
   * @param {number} maxWidth
   * @param {number} maxHeight
   * @param {Point} panAreaSize
   */
  return _createClass(ZoomLevel, [{
    key: "update",
    value: function update(maxWidth, maxHeight, panAreaSize) {
      /** @type {Point} */
      var elementSize = {
        x: maxWidth,
        y: maxHeight
      };
      this.elementSize = elementSize;
      this.panAreaSize = panAreaSize;
      var hRatio = panAreaSize.x / elementSize.x;
      var vRatio = panAreaSize.y / elementSize.y;
      this.fit = Math.min(1, hRatio < vRatio ? hRatio : vRatio);
      this.fill = Math.min(1, hRatio > vRatio ? hRatio : vRatio); // zoom.vFill defines zoom level of the image
      // when it has 100% of viewport vertical space (height)

      this.vFill = Math.min(1, vRatio);
      this.initial = this._getInitial();
      this.secondary = this._getSecondary();
      this.max = Math.max(this.initial, this.secondary, this._getMax());
      this.min = Math.min(this.fit, this.initial, this.secondary);
      if (this.pswp) {
        this.pswp.dispatch('zoomLevelsUpdate', {
          zoomLevels: this,
          slideData: this.itemData
        });
      }
    }
    /**
     * Parses user-defined zoom option.
     *
     * @private
     * @param {'initial' | 'secondary' | 'max'} optionPrefix Zoom level option prefix (initial, secondary, max)
     * @returns { number | undefined }
     */
  }, {
    key: "_parseZoomLevelOption",
    value: function _parseZoomLevelOption(optionPrefix) {
      var optionName = /** @type {'initialZoomLevel' | 'secondaryZoomLevel' | 'maxZoomLevel'} */
      optionPrefix + 'ZoomLevel';
      var optionValue = this.options[optionName];
      if (!optionValue) {
        return;
      }
      if (typeof optionValue === 'function') {
        return optionValue(this);
      }
      if (optionValue === 'fill') {
        return this.fill;
      }
      if (optionValue === 'fit') {
        return this.fit;
      }
      return Number(optionValue);
    }
    /**
     * Get zoom level to which image will be zoomed after double-tap gesture,
     * or when user clicks on zoom icon,
     * or mouse-click on image itself.
     * If you return 1 image will be zoomed to its original size.
     *
     * @private
     * @return {number}
     */
  }, {
    key: "_getSecondary",
    value: function _getSecondary() {
      var currZoomLevel = this._parseZoomLevelOption('secondary');
      if (currZoomLevel) {
        return currZoomLevel;
      } // 3x of "fit" state, but not larger than original

      currZoomLevel = Math.min(1, this.fit * 3);
      if (this.elementSize && currZoomLevel * this.elementSize.x > MAX_IMAGE_WIDTH) {
        currZoomLevel = MAX_IMAGE_WIDTH / this.elementSize.x;
      }
      return currZoomLevel;
    }
    /**
     * Get initial image zoom level.
     *
     * @private
     * @return {number}
     */
  }, {
    key: "_getInitial",
    value: function _getInitial() {
      return this._parseZoomLevelOption('initial') || this.fit;
    }
    /**
     * Maximum zoom level when user zooms
     * via zoom/pinch gesture,
     * via cmd/ctrl-wheel or via trackpad.
     *
     * @private
     * @return {number}
     */
  }, {
    key: "_getMax",
    value: function _getMax() {
      // max zoom level is x4 from "fit state",
      // used for zoom gesture and ctrl/trackpad zoom
      return this._parseZoomLevelOption('max') || Math.max(1, this.fit * 4);
    }
  }]);
}();
/**
 * Lazy-load an image
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * @param {SlideData} itemData Data about the slide
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox instance
 * @param {number} index
 * @returns {Content} Image that is being decoded or false.
 */
function _lazyLoadData(itemData, instance, index) {
  var content = instance.createContentFromData(itemData, index);
  /** @type {ZoomLevel | undefined} */

  var zoomLevel;
  var options = instance.options; // We need to know dimensions of the image to preload it,
  // as it might use srcset, and we need to define sizes

  if (options) {
    zoomLevel = new ZoomLevel(options, itemData, -1);
    var viewportSize;
    if (instance.pswp) {
      viewportSize = instance.pswp.viewportSize;
    } else {
      viewportSize = getViewportSize(options, instance);
    }
    var panAreaSize = getPanAreaSize(options, viewportSize, itemData, index);
    zoomLevel.update(content.width, content.height, panAreaSize);
  }
  content.lazyLoad();
  if (zoomLevel) {
    content.setDisplayedSize(Math.ceil(content.width * zoomLevel.initial), Math.ceil(content.height * zoomLevel.initial));
  }
  return content;
}
/**
 * Lazy-loads specific slide.
 * This function is used both by Lightbox and PhotoSwipe core,
 * thus it can be called before dialog is opened.
 *
 * By default, it loads image based on viewport size and initial zoom level.
 *
 * @param {number} index Slide index
 * @param {PhotoSwipeBase} instance PhotoSwipe or PhotoSwipeLightbox eventable instance
 * @returns {Content | undefined}
 */

function lazyLoadSlide(index, instance) {
  var itemData = instance.getItemData(index);
  if (instance.dispatch('lazyLoadSlide', {
    index: index,
    itemData: itemData
  }).defaultPrevented) {
    return;
  }
  return _lazyLoadData(itemData, instance, index);
}

/** @typedef {import("../photoswipe.js").default} PhotoSwipe */

/** @typedef {import("../slide/slide.js").SlideData} SlideData */

/**
 * PhotoSwipe base class that can retrieve data about every slide.
 * Shared by PhotoSwipe Core and PhotoSwipe Lightbox
 */
var PhotoSwipeBase = /*#__PURE__*/function (_Eventable) {
  function PhotoSwipeBase() {
    _classCallCheck(this, PhotoSwipeBase);
    return _callSuper(this, PhotoSwipeBase, arguments);
  }
  _inherits(PhotoSwipeBase, _Eventable);
  return _createClass(PhotoSwipeBase, [{
    key: "getNumItems",
    value:
    /**
     * Get total number of slides
     *
     * @returns {number}
     */
    function getNumItems() {
      var _this$options;
      var numItems = 0;
      var dataSource = (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.dataSource;
      if (dataSource && 'length' in dataSource) {
        // may be an array or just object with length property
        numItems = dataSource.length;
      } else if (dataSource && 'gallery' in dataSource) {
        // query DOM elements
        if (!dataSource.items) {
          dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
        }
        if (dataSource.items) {
          numItems = dataSource.items.length;
        }
      } // legacy event, before filters were introduced

      var event = this.dispatch('numItems', {
        dataSource: dataSource,
        numItems: numItems
      });
      return this.applyFilters('numItems', event.numItems, dataSource);
    }
    /**
     * @param {SlideData} slideData
     * @param {number} index
     * @returns {Content}
     */
  }, {
    key: "createContentFromData",
    value: function createContentFromData(slideData, index) {
      return new Content(slideData, this, index);
    }
    /**
     * Get item data by index.
     *
     * "item data" should contain normalized information that PhotoSwipe needs to generate a slide.
     * For example, it may contain properties like
     * `src`, `srcset`, `w`, `h`, which will be used to generate a slide with image.
     *
     * @param {number} index
     * @returns {SlideData}
     */
  }, {
    key: "getItemData",
    value: function getItemData(index) {
      var _this$options2;
      var dataSource = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.dataSource;
      /** @type {SlideData | HTMLElement} */

      var dataSourceItem = {};
      if (Array.isArray(dataSource)) {
        // Datasource is an array of elements
        dataSourceItem = dataSource[index];
      } else if (dataSource && 'gallery' in dataSource) {
        // dataSource has gallery property,
        // thus it was created by Lightbox, based on
        // gallery and children options
        // query DOM elements
        if (!dataSource.items) {
          dataSource.items = this._getGalleryDOMElements(dataSource.gallery);
        }
        dataSourceItem = dataSource.items[index];
      }
      var itemData = dataSourceItem;
      if (itemData instanceof Element) {
        itemData = this._domElementToItemData(itemData);
      } // Dispatching the itemData event,
      // it's a legacy verion before filters were introduced

      var event = this.dispatch('itemData', {
        itemData: itemData || {},
        index: index
      });
      return this.applyFilters('itemData', event.itemData, index);
    }
    /**
     * Get array of gallery DOM elements,
     * based on childSelector and gallery element.
     *
     * @param {HTMLElement} galleryElement
     * @returns {HTMLElement[]}
     */
  }, {
    key: "_getGalleryDOMElements",
    value: function _getGalleryDOMElements(galleryElement) {
      var _this$options3, _this$options4;
      if ((_this$options3 = this.options) !== null && _this$options3 !== void 0 && _this$options3.children || (_this$options4 = this.options) !== null && _this$options4 !== void 0 && _this$options4.childSelector) {
        return getElementsFromOption(this.options.children, this.options.childSelector, galleryElement) || [];
      }
      return [galleryElement];
    }
    /**
     * Converts DOM element to item data object.
     *
     * @param {HTMLElement} element DOM element
     * @returns {SlideData}
     */
  }, {
    key: "_domElementToItemData",
    value: function _domElementToItemData(element) {
      /** @type {SlideData} */
      var itemData = {
        element: element
      };
      var linkEl = /** @type {HTMLAnchorElement} */
      element.tagName === 'A' ? element : element.querySelector('a');
      if (linkEl) {
        // src comes from data-pswp-src attribute,
        // if it's empty link href is used
        itemData.src = linkEl.dataset.pswpSrc || linkEl.href;
        if (linkEl.dataset.pswpSrcset) {
          itemData.srcset = linkEl.dataset.pswpSrcset;
        }
        itemData.width = linkEl.dataset.pswpWidth ? parseInt(linkEl.dataset.pswpWidth, 10) : 0;
        itemData.height = linkEl.dataset.pswpHeight ? parseInt(linkEl.dataset.pswpHeight, 10) : 0; // support legacy w & h properties

        itemData.w = itemData.width;
        itemData.h = itemData.height;
        if (linkEl.dataset.pswpType) {
          itemData.type = linkEl.dataset.pswpType;
        }
        var thumbnailEl = element.querySelector('img');
        if (thumbnailEl) {
          var _thumbnailEl$getAttri;

          // msrc is URL to placeholder image that's displayed before large image is loaded
          // by default it's displayed only for the first slide
          itemData.msrc = thumbnailEl.currentSrc || thumbnailEl.src;
          itemData.alt = (_thumbnailEl$getAttri = thumbnailEl.getAttribute('alt')) !== null && _thumbnailEl$getAttri !== void 0 ? _thumbnailEl$getAttri : '';
        }
        if (linkEl.dataset.pswpCropped || linkEl.dataset.cropped) {
          itemData.thumbCropped = true;
        }
      }
      return this.applyFilters('domItemData', itemData, element, linkEl);
    }
    /**
     * Lazy-load by slide data
     *
     * @param {SlideData} itemData Data about the slide
     * @param {number} index
     * @returns {Content} Image that is being decoded or false.
     */
  }, {
    key: "lazyLoadData",
    value: function lazyLoadData(itemData, index) {
      return _lazyLoadData(itemData, this, index);
    }
  }]);
}(Eventable);
/**
 * @template T
 * @typedef {import('../types.js').Type<T>} Type<T>
 */
/** @typedef {import('../photoswipe.js').default} PhotoSwipe */
/** @typedef {import('../photoswipe.js').PhotoSwipeOptions} PhotoSwipeOptions */
/** @typedef {import('../photoswipe.js').DataSource} DataSource */
/** @typedef {import('../photoswipe.js').Point} Point */
/** @typedef {import('../slide/content.js').default} Content */
/** @typedef {import('../core/eventable.js').PhotoSwipeEventsMap} PhotoSwipeEventsMap */
/** @typedef {import('../core/eventable.js').PhotoSwipeFiltersMap} PhotoSwipeFiltersMap */
/**
 * @template {keyof PhotoSwipeEventsMap} T
 * @typedef {import('../core/eventable.js').EventCallback<T>} EventCallback<T>
 */
/**
 * PhotoSwipe Lightbox
 *
 * - If user has unsupported browser it falls back to default browser action (just opens URL)
 * - Binds click event to links that should open PhotoSwipe
 * - parses DOM strcture for PhotoSwipe (retrieves large image URLs and sizes)
 * - Initializes PhotoSwipe
 *
 *
 * Loader options use the same object as PhotoSwipe, and supports such options:
 *
 * gallery - Element | Element[] | NodeList | string selector for the gallery element
 * children - Element | Element[] | NodeList | string selector for the gallery children
 *
 */
var PhotoSwipeLightbox = /*#__PURE__*/function (_PhotoSwipeBase) {
  /**
   * @param {PhotoSwipeOptions} [options]
   */
  function PhotoSwipeLightbox(options) {
    var _this6;
    _classCallCheck(this, PhotoSwipeLightbox);
    _this6 = _callSuper(this, PhotoSwipeLightbox);
    /** @type {PhotoSwipeOptions} */

    _this6.options = options || {};
    _this6._uid = 0;
    _this6.shouldOpen = false;
    /**
     * @private
     * @type {Content | undefined}
     */

    _this6._preloadedContent = undefined;
    _this6.onThumbnailsClick = _this6.onThumbnailsClick.bind(_this6);
    return _this6;
  }
  /**
   * Initialize lightbox, should be called only once.
   * It's not included in the main constructor, so you may bind events before it.
   */
  _inherits(PhotoSwipeLightbox, _PhotoSwipeBase);
  return _createClass(PhotoSwipeLightbox, [{
    key: "init",
    value: function init() {
      var _this7 = this;
      // Bind click events to each gallery
      getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function (galleryElement) {
        galleryElement.addEventListener('click', _this7.onThumbnailsClick, false);
      });
    }
    /**
     * @param {MouseEvent} e
     */
  }, {
    key: "onThumbnailsClick",
    value: function onThumbnailsClick(e) {
      // Exit and allow default browser action if:
      if (specialKeyUsed(e) // ... if clicked with a special key (ctrl/cmd...)
      || window.pswp) {
        // ... if PhotoSwipe is already open
        return;
      } // If both clientX and clientY are 0 or not defined,
      // the event is likely triggered by keyboard,
      // so we do not pass the initialPoint
      //
      // Note that some screen readers emulate the mouse position,
      // so it's not the ideal way to detect them.
      //

      /** @type {Point | null} */

      var initialPoint = {
        x: e.clientX,
        y: e.clientY
      };
      if (!initialPoint.x && !initialPoint.y) {
        initialPoint = null;
      }
      var clickedIndex = this.getClickedIndex(e);
      clickedIndex = this.applyFilters('clickedIndex', clickedIndex, e, this);
      /** @type {DataSource} */

      var dataSource = {
        gallery: /** @type {HTMLElement} */
        e.currentTarget
      };
      if (clickedIndex >= 0) {
        e.preventDefault();
        this.loadAndOpen(clickedIndex, dataSource, initialPoint);
      }
    }
    /**
     * Get index of gallery item that was clicked.
     *
     * @param {MouseEvent} e click event
     * @returns {number}
     */
  }, {
    key: "getClickedIndex",
    value: function getClickedIndex(e) {
      // legacy option
      if (this.options.getClickedIndexFn) {
        return this.options.getClickedIndexFn.call(this, e);
      }
      var clickedTarget = /** @type {HTMLElement} */
      e.target;
      var childElements = getElementsFromOption(this.options.children, this.options.childSelector, /** @type {HTMLElement} */
      e.currentTarget);
      var clickedChildIndex = childElements.findIndex(function (child) {
        return child === clickedTarget || child.contains(clickedTarget);
      });
      if (clickedChildIndex !== -1) {
        return clickedChildIndex;
      } else if (this.options.children || this.options.childSelector) {
        // click wasn't on a child element
        return -1;
      } // There is only one item (which is the gallery)

      return 0;
    }
    /**
     * Load and open PhotoSwipe
     *
     * @param {number} index
     * @param {DataSource} [dataSource]
     * @param {Point | null} [initialPoint]
     * @returns {boolean}
     */
  }, {
    key: "loadAndOpen",
    value: function loadAndOpen(index, dataSource, initialPoint) {
      // Check if the gallery is already open
      if (window.pswp || !this.options) {
        return false;
      } // Use the first gallery element if dataSource is not provided

      if (!dataSource && this.options.gallery && this.options.children) {
        var galleryElements = getElementsFromOption(this.options.gallery);
        if (galleryElements[0]) {
          dataSource = {
            gallery: galleryElements[0]
          };
        }
      } // set initial index

      this.options.index = index; // define options for PhotoSwipe constructor

      this.options.initialPointerPos = initialPoint;
      this.shouldOpen = true;
      this.preload(index, dataSource);
      return true;
    }
    /**
     * Load the main module and the slide content by index
     *
     * @param {number} index
     * @param {DataSource} [dataSource]
     */
  }, {
    key: "preload",
    value: function preload(index, dataSource) {
      var _this8 = this;
      var options = this.options;
      if (dataSource) {
        options.dataSource = dataSource;
      } // Add the main module

      /** @type {Promise<Type<PhotoSwipe>>[]} */

      var promiseArray = [];
      var pswpModuleType = _typeof(options.pswpModule);
      if (isPswpClass(options.pswpModule)) {
        promiseArray.push(Promise.resolve( /** @type {Type<PhotoSwipe>} */
        options.pswpModule));
      } else if (pswpModuleType === 'string') {
        throw new Error('pswpModule as string is no longer supported');
      } else if (pswpModuleType === 'function') {
        promiseArray.push( /** @type {() => Promise<Type<PhotoSwipe>>} */
        options.pswpModule());
      } else {
        throw new Error('pswpModule is not valid');
      } // Add custom-defined promise, if any

      if (typeof options.openPromise === 'function') {
        // allow developers to perform some task before opening
        promiseArray.push(options.openPromise());
      }
      if (options.preloadFirstSlide !== false && index >= 0) {
        this._preloadedContent = lazyLoadSlide(index, this);
      } // Wait till all promises resolve and open PhotoSwipe

      var uid = ++this._uid;
      Promise.all(promiseArray).then(function (iterableModules) {
        if (_this8.shouldOpen) {
          var mainModule = iterableModules[0];
          _this8._openPhotoswipe(mainModule, uid);
        }
      });
    }
    /**
     * @private
     * @param {Type<PhotoSwipe> | { default: Type<PhotoSwipe> }} module
     * @param {number} uid
     */
  }, {
    key: "_openPhotoswipe",
    value: function _openPhotoswipe(module, uid) {
      var _this9 = this;
      // Cancel opening if UID doesn't match the current one
      // (if user clicked on another gallery item before current was loaded).
      //
      // Or if shouldOpen flag is set to false
      // (developer may modify it via public API)
      if (uid !== this._uid && this.shouldOpen) {
        return;
      }
      this.shouldOpen = false; // PhotoSwipe is already open

      if (window.pswp) {
        return;
      }
      /**
       * Pass data to PhotoSwipe and open init
       *
       * @type {PhotoSwipe}
       */

      var pswp = _typeof(module) === 'object' ? new module["default"](this.options) // eslint-disable-line
      : new module(this.options); // eslint-disable-line

      this.pswp = pswp;
      window.pswp = pswp; // map listeners from Lightbox to PhotoSwipe Core

      /** @type {(keyof PhotoSwipeEventsMap)[]} */

      Object.keys(this._listeners).forEach(function (name) {
        var _this$_listeners$name;
        (_this$_listeners$name = _this9._listeners[name]) === null || _this$_listeners$name === void 0 || _this$_listeners$name.forEach(function (fn) {
          pswp.on(name, /** @type {EventCallback<typeof name>} */
          fn);
        });
      }); // same with filters

      /** @type {(keyof PhotoSwipeFiltersMap)[]} */

      Object.keys(this._filters).forEach(function (name) {
        var _this$_filters$name;
        (_this$_filters$name = _this9._filters[name]) === null || _this$_filters$name === void 0 || _this$_filters$name.forEach(function (filter) {
          pswp.addFilter(name, filter.fn, filter.priority);
        });
      });
      if (this._preloadedContent) {
        pswp.contentLoader.addToCache(this._preloadedContent);
        this._preloadedContent = undefined;
      }
      pswp.on('destroy', function () {
        // clean up public variables
        _this9.pswp = undefined;
        delete window.pswp;
      });
      pswp.init();
    }
    /**
     * Unbinds all events, closes PhotoSwipe if it's open.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var _this10 = this;
      var _this$pswp;
      (_this$pswp = this.pswp) === null || _this$pswp === void 0 || _this$pswp.destroy();
      this.shouldOpen = false;
      this._listeners = {};
      getElementsFromOption(this.options.gallery, this.options.gallerySelector).forEach(function (galleryElement) {
        galleryElement.removeEventListener('click', _this10.onThumbnailsClick, false);
      });
    }
  }]);
}(PhotoSwipeBase);


/***/ }),

/***/ "./scripts/util/wheelcontrols.js":
/*!***************************************!*\
  !*** ./scripts/util/wheelcontrols.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ wheelControls)
/* harmony export */ });
function wheelControls(slider) {
  var touchTimeout;
  var position;
  var wheelActive;
  function dispatch(e, name) {
    position.x -= e.deltaX;
    position.y -= e.deltaY;
    slider.container.dispatchEvent(new CustomEvent(name, {
      detail: {
        x: position.x,
        y: position.y
      }
    }));
  }
  function wheelStart(e) {
    position = {
      x: e.pageX,
      y: e.pageY
    };
    dispatch(e, 'ksDragStart');
  }
  function wheel(e) {
    dispatch(e, 'ksDrag');
  }
  function wheelEnd(e) {
    dispatch(e, 'ksDragEnd');
  }
  function eventWheel(e) {
    if (e.deltaX !== 0) {
      // only disable page scroll when scrolling x
      e.preventDefault();
    }
    if (!wheelActive) {
      wheelStart(e);
      wheelActive = true;
    }
    wheel(e);
    clearTimeout(touchTimeout);
    touchTimeout = setTimeout(function () {
      wheelActive = false;
      wheelEnd(e);
    }, 50);
  }
  slider.on('created', function () {
    slider.container.addEventListener('wheel', eventWheel, {
      passive: false
    });
  });
}

/***/ }),

/***/ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[2]!./scripts/util/photoswipe.css":
/*!***********************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[2]!./scripts/util/photoswipe.css ***!
  \***********************************************************************************************************************************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0__);
// Imports

var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_0___default()(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! PhotoSwipe main CSS by Dmytro Semenov | photoswipe.com */\n\n.pswp {\n    --pswp-bg: #000;\n    --pswp-placeholder-bg: #222;\n    \n  \n    --pswp-root-z-index: 100000;\n    \n    --pswp-preloader-color: rgba(79, 79, 79, 0.4);\n    --pswp-preloader-color-secondary: rgba(255, 255, 255, 0.9);\n    \n    /* defined via js:\n    --pswp-transition-duration: 333ms; */\n    \n    --pswp-icon-color: #fff;\n    --pswp-icon-color-secondary: #4f4f4f;\n    --pswp-icon-stroke-color: #4f4f4f;\n    --pswp-icon-stroke-width: 2px;\n  \n    --pswp-error-text-color: var(--pswp-icon-color);\n  }\n  \n  \n  /*\n      Styles for basic PhotoSwipe (pswp) functionality (sliding area, open/close transitions)\n  */\n  \n  .pswp {\n      position: fixed;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: var(--pswp-root-z-index);\n      display: none;\n      touch-action: none;\n      outline: 0;\n      opacity: 0.003;\n      contain: layout style size;\n      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  }\n  \n  /* Prevents focus outline on the root element,\n    (it may be focused initially) */\n  .pswp:focus {\n    outline: 0;\n  }\n  \n  .pswp * {\n    box-sizing: border-box;\n  }\n  \n  .pswp img {\n    max-width: none;\n  }\n  \n  .pswp--open {\n      display: block;\n  }\n  \n  .pswp,\n  .pswp__bg {\n      transform: translateZ(0);\n      will-change: opacity;\n  }\n  \n  .pswp__bg {\n    opacity: 0.005;\n      background: var(--pswp-bg);\n  }\n  \n  .pswp,\n  .pswp__scroll-wrap {\n      overflow: hidden;\n  }\n  \n  .pswp__scroll-wrap,\n  .pswp__bg,\n  .pswp__container,\n  .pswp__item,\n  .pswp__content,\n  .pswp__img,\n  .pswp__zoom-wrap {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n  }\n  \n  .pswp__img,\n  .pswp__zoom-wrap {\n      width: auto;\n      height: auto;\n  }\n  \n  .pswp--click-to-zoom.pswp--zoom-allowed .pswp__img {\n      cursor: zoom-in;\n  }\n  \n  .pswp--click-to-zoom.pswp--zoomed-in .pswp__img {\n      cursor: move;\n      cursor: grab;\n  }\n  \n  .pswp--click-to-zoom.pswp--zoomed-in .pswp__img:active {\n    cursor: grabbing;\n  }\n  \n  /* :active to override grabbing cursor */\n  .pswp--no-mouse-drag.pswp--zoomed-in .pswp__img,\n  .pswp--no-mouse-drag.pswp--zoomed-in .pswp__img:active,\n  .pswp__img {\n      cursor: zoom-out;\n  }\n  \n  \n  /* Prevent selection and tap highlights */\n  .pswp__container,\n  .pswp__img,\n  .pswp__button,\n  .pswp__counter {\n      -webkit-user-select: none;\n      -moz-user-select: none;\n      user-select: none;\n  }\n  \n  .pswp__item {\n      /* z-index for fade transition */\n      z-index: 1;\n      overflow: hidden;\n  }\n  \n  .pswp__hidden {\n      display: none !important;\n  }\n  \n  /* Allow to click through pswp__content element, but not its children */\n  .pswp__content {\n    pointer-events: none;\n  }\n  .pswp__content > * {\n    pointer-events: auto;\n  }\n  \n  \n  /*\n  \n    PhotoSwipe UI\n  \n  */\n  \n  /*\n      Error message appears when image is not loaded\n      (JS option errorMsg controls markup)\n  */\n  .pswp__error-msg-container {\n    display: grid;\n  }\n  .pswp__error-msg {\n      margin: auto;\n      font-size: 1em;\n      line-height: 1;\n      color: var(--pswp-error-text-color);\n  }\n  \n  /*\n  class pswp__hide-on-close is applied to elements that\n  should hide (for example fade out) when PhotoSwipe is closed\n  and show (for example fade in) when PhotoSwipe is opened\n   */\n  .pswp .pswp__hide-on-close {\n      opacity: 0.005;\n      will-change: opacity;\n      transition: opacity var(--pswp-transition-duration) cubic-bezier(0.4, 0, 0.22, 1);\n      z-index: 10; /* always overlap slide content */\n      pointer-events: none; /* hidden elements should not be clickable */\n  }\n  \n  /* class pswp--ui-visible is added when opening or closing transition starts */\n  .pswp--ui-visible .pswp__hide-on-close {\n      opacity: 1;\n      pointer-events: auto;\n  }\n  \n  /* <button> styles, including css reset */\n  .pswp__button {\n      position: relative;\n      display: block;\n      width: 50px;\n      height: 60px;\n      padding: 0;\n      margin: 0;\n      overflow: hidden;\n      cursor: pointer;\n      background: none;\n      border: 0;\n      box-shadow: none;\n      opacity: 0.85;\n      -webkit-appearance: none;\n      -webkit-touch-callout: none;\n  }\n  \n  .pswp__button:hover,\n  .pswp__button:active,\n  .pswp__button:focus {\n    transition: none;\n    padding: 0;\n    background: none;\n    border: 0;\n    box-shadow: none;\n    opacity: 1;\n  }\n  \n  .pswp__button:disabled {\n    opacity: 0.3;\n    cursor: auto;\n  }\n  \n  .pswp__icn {\n    fill: var(--pswp-icon-color);\n    color: var(--pswp-icon-color-secondary);\n  }\n  \n  .pswp__icn {\n    position: absolute;\n    top: 14px;\n    left: 9px;\n    width: 32px;\n    height: 32px;\n    overflow: hidden;\n    pointer-events: none;\n  }\n  \n  .pswp__icn-shadow {\n    stroke: var(--pswp-icon-stroke-color);\n    stroke-width: var(--pswp-icon-stroke-width);\n    fill: none;\n  }\n  \n  .pswp__icn:focus {\n      outline: 0;\n  }\n  \n  /*\n      div element that matches size of large image,\n      large image loads on top of it,\n      used when msrc is not provided\n  */\n  div.pswp__img--placeholder,\n  .pswp__img--with-bg {\n      background: var(--pswp-placeholder-bg);\n  }\n  \n  .pswp__top-bar {\n      position: absolute;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 60px;\n      display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n      z-index: 10;\n  \n      /* allow events to pass through top bar itself */\n      pointer-events: none !important;\n  }\n  .pswp__top-bar > * {\n    pointer-events: auto;\n    /* this makes transition significantly more smooth,\n       even though inner elements are not animated */\n    will-change: opacity;\n  }\n  \n  \n  /*\n  \n    Close button\n  \n  */\n  .pswp__button--close {\n    margin-right: 6px;\n  }\n  \n  \n  /*\n  \n    Arrow buttons\n  \n  */\n  .pswp__button--arrow {\n    position: absolute;\n    top: 0;\n    width: 75px;\n    height: 100px;\n    top: 50%;\n    margin-top: -50px;\n  }\n  \n  .pswp__button--arrow:disabled {\n    display: none;\n    cursor: default;\n  }\n  \n  .pswp__button--arrow .pswp__icn {\n    top: 50%;\n    margin-top: -30px;\n    width: 60px;\n    height: 60px;\n    background: none;\n    border-radius: 0;\n  }\n  \n  .pswp--one-slide .pswp__button--arrow {\n    display: none;\n  }\n  \n  /* hide arrows on touch screens */\n  .pswp--touch .pswp__button--arrow {\n    visibility: hidden;\n  }\n  \n  /* show arrows only after mouse was used */\n  .pswp--has_mouse .pswp__button--arrow {\n    visibility: visible;\n  }\n  \n  .pswp__button--arrow--prev {\n    right: auto;\n    left: 0px;\n  }\n  \n  .pswp__button--arrow--next {\n    right: 0px;\n  }\n  .pswp__button--arrow--next .pswp__icn {\n    left: auto;\n    right: 14px;\n    /* flip horizontally */\n    transform: scale(-1, 1);\n  }\n  \n  /*\n  \n    Zoom button\n  \n  */\n  .pswp__button--zoom {\n    display: none;\n  }\n  \n  .pswp--zoom-allowed .pswp__button--zoom {\n    display: block;\n  }\n  \n  /* \"+\" => \"-\" */\n  .pswp--zoomed-in .pswp__zoom-icn-bar-v {\n    display: none;\n  }\n  \n  \n  /*\n  \n    Loading indicator\n  \n  */\n  .pswp__preloader {\n    position: relative;\n    overflow: hidden;\n    width: 50px;\n    height: 60px;\n    margin-right: auto;\n  }\n  \n  .pswp__preloader .pswp__icn {\n    opacity: 0;\n    transition: opacity 0.2s linear;\n    animation: pswp-clockwise 600ms linear infinite;\n  }\n  \n  .pswp__preloader--active .pswp__icn {\n    opacity: 0.85;\n  }\n  \n  @keyframes pswp-clockwise {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n  \n  /*\n  \n    \"1 of 10\" counter\n  \n  */\n  .pswp__counter {\n    height: 30px;\n    margin-top: 15px;\n    margin-inline-start: 20px;\n    font-size: 14px;\n    line-height: 30px;\n    color: var(--pswp-icon-color);\n    text-shadow: 1px 1px 3px var(--pswp-icon-color-secondary);\n    opacity: 0.85;\n  }\n  \n  .pswp--one-slide .pswp__counter {\n    display: none;\n  }", ""]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "./node_modules/css-loader/dist/runtime/api.js":
/*!*****************************************************!*\
  !*** ./node_modules/css-loader/dist/runtime/api.js ***!
  \*****************************************************/
/***/ ((module) => {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (cssWithMappingToString) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join("");
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === "string") {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, ""]];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

/***/ }),

/***/ "./scripts/util/photoswipe.css":
/*!*************************************!*\
  !*** ./scripts/util/photoswipe.css ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_laravel_mix_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! !../../node_modules/laravel-mix/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/laravel-mix/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
/* harmony import */ var _node_modules_laravel_mix_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_laravel_mix_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_1_node_modules_postcss_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_2_photoswipe_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! !!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[2]!./photoswipe.css */ "./node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[1]!./node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].oneOf[1].use[2]!./scripts/util/photoswipe.css");

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_laravel_mix_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_1_node_modules_postcss_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_2_photoswipe_css__WEBPACK_IMPORTED_MODULE_1__["default"], options);



/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_1_node_modules_postcss_loader_dist_cjs_js_ruleSet_1_rules_5_oneOf_1_use_2_photoswipe_css__WEBPACK_IMPORTED_MODULE_1__["default"].locals || {});

/***/ }),

/***/ "./node_modules/laravel-mix/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/*!*****************************************************************************************************!*\
  !*** ./node_modules/laravel-mix/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \*****************************************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : 0;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/***/ ((module) => {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	(() => {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = (chunkId) => {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce((promises, key) => {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = (chunkId) => {
/******/ 			// return url for filenames not based on template
/******/ 			if (chunkId === "scripts_util_photoswipe_esm_js") return "assets/" + chunkId + ".js";
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	(() => {
/******/ 		// This function allow to reference all chunks
/******/ 		__webpack_require__.miniCssF = (chunkId) => {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	(() => {
/******/ 		var inProgress = {};
/******/ 		// data-webpack is not used as build has no uniqueName
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = (url, done, key, chunkId) => {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 		
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = (prev, event) => {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach((fn) => (fn(event)));
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	(() => {
/******/ 		__webpack_require__.p = "/";
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/base": 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = (chunkId, promises) => {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = (event) => {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunk"] = self["webpackChunk"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./scripts/util/base.js ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _components_sections_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../components/sections/components */ "./scripts/components/sections/components.js");
/* harmony import */ var _components_core_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../components/core/components */ "./scripts/components/core/components.js");


window.app.add(_components_sections_components__WEBPACK_IMPORTED_MODULE_0__["default"]);
window.app.add(_components_core_components__WEBPACK_IMPORTED_MODULE_1__["default"]);
window.app.mount();
})();

/******/ })()
;